export default String.raw`
{% include 'partials/common/date-format.html' -%}

{% assign product = product-presentation.Product -%}
{% assign url = page.Url -%}
{% capture urlHref -%}{% include 'partials/common/user-link.html', userLink: url -%}{% endcapture -%}

{% assign inLookbook = false -%}
{% if include contains 'in-cart' -%}
	{% assign canBuy = true -%}
{% elseif include contains 'in-lookbook' -%}
	{% assign canBuy = true -%}
    {% assign inLookbook = true -%}
{% endif -%}

{% assign checked = false -%}
{% if include contains 'checked' -%}
	{% assign checked = true -%}
{% endif -%}

{% comment -%}<!-- Supplies -->{% endcomment -%}
{% assign suppliesSize = product.Supplies.Supplies | Size -%}
{% if product.Supplies != null and suppliesSize != 0 -%}
	{% comment -%}<!-- Keys -->{% endcomment -%}
	{% if page.QueryString contains 'keys' -%}
		{% assign queries = page.QueryString | Split:'&' -%}
		{% for query in queries -%}
			{% if query contains 'keys' -%}
				{% assign queryString = query | Split:'=' -%}
				{% assign joinedKeys = queryString[1] | Replace: '%2c', ',' -%}
				{% assign keys = joinedKeys | Split:',' -%}
			{% endif -%}
		{% endfor -%}
	{% else -%}
		{% if product.Supplies.Key != null -%}
			{% assign joinedKeys = product.Supplies.Key | Replace: '%2c', ',' -%}
			{% assign keys = joinedKeys | Split:',' -%}
		{% else -%}
			{% assign noParentSupply = product.Supplies.Supplies[0] -%}
			{% assign size = product.Supplies.AttributeNames | Size -%}
			{% for attribute in product.Supplies.AttributeNames -%}
				{% if forloop.index != 1 -%}
					{% assign noParentSupply = noParentSupply.Supplies[0] -%}
				{% endif -%}
				{% if forloop.index == size -%}
					{% assign joinedKeys = noParentSupply.Key | Replace: '%2c', ',' -%}
					{% assign keys = joinedKeys | Split:',' -%}
					{% assign noParentKey = true -%}
				{% endif -%}
			{% endfor -%}
		{% endif -%}
	{% endif -%}

	{% comment -%}<!-- Supply -->{% endcomment -%}
	{% assign supplies = product.Supplies.Supplies -%}
	{% for key in keys -%}
		{% for supply in supplies -%}
			{% if supply.ValueId == key -%}
				{% assign supplies = supply.Supplies -%}
				{% if supply.Key and product.Clip == true -%}
					{% assign supplyProduct = supply.Product -%}
				{% endif -%}
			{% endif -%}
		{% endfor -%}
	{% endfor -%}
{% endif -%}

{% comment -%}<!-- Product -->{% endcomment -%}
{% if product.Clip or product.Batch -%}
	{% if product.Supplies != null and suppliesSize != 0 -%}
		{% assign suppliesAsNotSupplies = false -%}
	{% endif -%}
{% endif -%}
{% if suppliesAsNotSupplies == false and product.Clip -%}
	{% assign activeProduct = supplyProduct -%}
{% else -%}
	{% assign activeProduct = product -%}
{% endif -%}

{% comment -%}<!-- Attribute selection for flat structure -->{% endcomment -%}
{% unless product.Clip or product.Batch -%}
	{% comment -%}<!-- AttributeIds from QueryString -->{% endcomment -%}
	{% if page.QueryString contains 'attributeId' -%}
		{% assign queries = page.QueryString | Split:'&' -%}
		{% for query in queries -%}
			{% if query contains 'attributeId' -%}
				{% assign queryString = query | Split:'=' -%}
				{% assign joinedAttributeIds = queryString[1] | Replace: '%2c', ',' -%}
				{% assign attributeIds = joinedAttributeIds | Split:',' -%}
			{% endif -%}
		{% endfor -%}
	{% else -%}
		{% comment -%}<!-- Default attribute selection if none specified -->{% endcomment -%}
		{% if activeProduct.AttributesPolyvalent != null and activeProduct.AttributesPolyvalent | Size > 0 -%}
			{% assign joinedAttributeIds = '' -%}
			{% for attribute in activeProduct.AttributesPolyvalent -%}
				{% if attribute.Values != null and attribute.Values | Size > 0 -%}
					{% assign stringValue = attribute.Values[0].ValueId | ToString | Append: ',' -%}
					{% assign joinedAttributeIds = joinedAttributeIds | Append: stringValue -%}
				{% endif -%}
			{% endfor -%}
			{% assign attributeIds = joinedAttributeIds | Split: ',' -%}
		{% endif -%}
	{% endif -%}
{% endunless -%}

{% comment -%}<!-- Unit -->{% endcomment -%}
{% if page.QueryString contains 'unit' -%}
	{% assign queries = page.QueryString | Split:'&' -%}
	{% for query in queries -%}
		{% if query contains 'unit' -%}
			{% assign queryString = query | Split:'=' -%}
			{% assign queriesSize = queryString | Size -%}
			{% if queriesSize > 1 -%}
				{% assign unitId = queryString[1] -%}
			{% else -%}
				{% assign unitId = null -%}
			{% endif -%}
			{% for unit in activeProduct.Units -%}
				{% if unit.Id == unitId -%}
					{% assign unitDimensions = unit.Dimensions-%}
					{% assign unitRatio = unit.Ratio -%}
					{% assign unitName = unit.Name -%}
					{% assign unitMultiplicity = unit.Multiplicity -%}
					{% assign defaultUnit = unit.Default -%}
				{% endif -%}
			{% endfor -%}
		{% endif -%}
	{% endfor -%}
{% else -%}
	{% for unit in activeProduct.Units -%}
		{% if unit.Default == true or unit.Id == null -%}
			{% assign unitDimensions = unit.Dimensions-%}
			{% assign unitId = unit.Id -%}
			{% assign unitRatio = unit.Ratio -%}
			{% assign unitName = unit.Name -%}
			{% assign unitMultiplicity = unit.Multiplicity -%}
			{% assign defaultUnit = unit.Default -%}
		{% endif -%}
	{% endfor -%}
{% endif -%}

{% comment -%}<!-- Stock control ON and stock empty -->{% endcomment -%}
{% assign noProductOnControlledStock = false -%}
{% if activeProduct.StockLevel.QuantityControl == true and activeProduct.StockLevel.Value == 0 -%}
	{% assign noProductOnControlledStock = true -%}
{% else -%}
	{% assign noProductOnControlledStock = false -%}
{% endif -%}

{% comment -%}<!-- Show stock for not -->{% endcomment -%}
{% if config.Stock.Enabled == true -%}
	{% if usr.Authenticated == false and settings.notAuthStock == 'no' -%}
		{% assign showStock = false -%}
	{% else -%}
		{% assign showStock = true -%}
	{% endif -%}
{% endif -%}

{% comment -%}<!-- Current cart -->{% endcomment -%}
{% if customer.Carts[0] or customer.Cart.EditedOrderId -%}
	{% assign inquiryExists = false -%}
	{% assign lastCartId = -1 -%}
	{% for oneOfCart in customer.Carts -%}
		{% if oneOfCart.Current -%}
			{% assign currentCartId = oneOfCart.Id -%}
			{% assign currentCartName = oneOfCart.Name -%}
		{% endif -%}
		{% if oneOfCart.Inquiry -%}
			{% assign inquiryExists = true -%}
			{% assign inquiryId = oneOfCart.Id -%}
		{% else -%}
			{% assign lastCartId = oneOfCart.Id -%}
		{% endif -%}
	{% endfor -%}
{% endif -%}

{% comment -%}<!-- Reviews -->{% endcomment -%}
{% if config.Reviews.Enabled -%}
	{% if config.Reviews.AuthenticationRequired == false -%}
		{% assign canAddReview = true -%}
	{% elseif customer.Authenticated == true -%}
		{% assign canAddReview = true -%}
	{% else -%}
		{% assign canAddReview = false -%}
	{% endif -%}
{% endif -%}

{% comment -%}<!-- Table view -->{% endcomment -%}
{% if product.Archival == false -%}
	{% if suppliesAsNotSupplies == false or activeProduct.AttributesPolyvalent[0] -%}
		{% if activeProduct.AttributesPolyvalent[0] -%}
			{% if activeProduct.AskForPrice == false -%}
				{% assign tableView = true -%}
			{% else -%}
				{% if suppliesSize > 1 -%}
					{% assign tableView = true -%}
				{% else -%}
					{% if product.Clip == true -%}
						{% assign tableView = true -%}
					{% else -%}
						{% assign tableView = false -%}
					{% endif -%}
				{% endif -%}
			{% endif -%}
		{% else -%}
			{% assign tableView = true -%}
		{% endif -%}
	{% else -%}
		{% assign tableView = false -%}
	{% endif -%}
{% else -%}
	{% assign tableView = false -%}
{% endif -%}

{% comment -%}<!-- Graphical variants -->{% endcomment -%}
{% assign graphicalVariants = false -%}
{% if settings.grapicalVariantsPresentation != 'Variants_No' -%}
	{% assign graphicalVariants = true -%}
{% endif -%}

{% if graphicalVariants and settings.grapicalVariantsPresentation == 'Variants_Colors' %}
	{% assign lang = page.Language | Upcase -%}
	{% capture settingsKey -%}grapicalVariantsPresentationColors{{ lang }}{% endcapture -%}
	{% if settings[settingsKey] -%}
		{% assign colorVariants = settings[settingsKey] | Split: '|||' -%}
	{% else -%}
		{% assign colorVariants = settings.grapicalVariantsPresentationColorsDefault | Split: '|||' -%}
	{% endif -%}
{% endif -%}

{% if graphicalVariants %}
	{% assign graphicalVariantsLimit = 10 -%}
	{% if settings.grapicalVariantsPresentation == 'Variants_Colors' -%}
		{% assign graphicalVariantsLimit = 12 -%}
	{% elseif settings.grapicalVariantsPresentation == 'Variants_Thumbnails' -%}
		{% assign graphicalVariantsLimit = 7 -%}
	{% else settings.grapicalVariantsPresentation == 'Variants_DropDownList' -%}
		{% assign graphicalVariantsLimit = 9 -%}
	{% endif -%}
{% endif -%}

{% comment -%}<!-- Product type -->{% endcomment -%}
{% if product.Batch -%}
	{% assign productType = 'batch' -%}
{% elsif product.Clip -%}
	{% assign productType = 'clip' -%}
{% else -%}
	{% assign productType = 'simple' -%}
{% endif -%}

{% assign showCouponsOnProductsLists = false -%}
{% assign showCouponsPopup = false -%}
{% if settings.couponsPresentation == "yes" and settings.showCouponsOnProductsLists == "yes" -%}
    {% assign showCouponsOnProductsLists = true -%}
{% endif -%}
{% if product.HasCoupons and showCouponsOnProductsLists -%}
    {% assign showCouponsPopup = true -%}
{% endif -%}

<dialog class="dialog add-variants-to-cart-from-prod-list-popup-background add-variants-to-cart-from-prod-list-popup-background-js container-to-remove-js remove-js">
	<input type="hidden" name="productType" value="{{ productType }}">
    <div class="popup add-variants-to-cart-from-prod-list-popup stop-propagation-js">
		<div class="popup__header">
			<h2 class="title">{{translations.ChooseProductVariant}}</h2>
			<form method="dialog">
				<button>
					<svg class="close-js">
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
					</svg>
				</button>
			</form>
		</div>
        
        <div class="popup__content product-container-js">
			<div class="product">
				<div class="product__image-wrapper">
					{% if activeProduct.Image -%}
						{{ activeProduct | Img: 'small' }}
					{% else -%}
						<svg width="40" height="40">
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#image-{{settings.iconStyle}}"></use>
						</svg>
					{% endif -%}
				</div>
				<div class="product__info">
					<a href="{{ page.BaseHref }}{{ product.Url }}">
						<h4 class="product__name">{{ product.Name | H }}</h4>
					</a>
					{% unless settings.showAvailabilityStatus == 'no' and activeProduct.Availability.Status == 1 -%}
						{% if activeProduct.Availability.Text != '' and product.Archival == false -%}
							<div class="product__availability">{{ translations.Availability }}: {{ activeProduct.Availability.Text }} {% if activeProduct.Availability.Date != null -%}(<time>{{ activeProduct.Availability.Date | Date:dateFormat }}</time>){% endif -%}</div>
						{% endif -%}
					{% endunless -%}
				</div>
			</div>

			<div class="at-least-one-product-info at-least-one-product-info-js hidden-js">
				<svg width="24" height="24">
					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#exclamation-circle-{{settings.iconStyle}}"></use>
				</svg>
				{{ translations.FillQuantityOfChoosenProducts }}
			</div>
			<div class="at-least-one-product-info proper-amount-info-js hidden-js">
				<svg width="24" height="24">
					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#exclamation-circle-{{settings.iconStyle}}"></use>
				</svg>
			</div>

			{% if product.Archival == false -%}
				{% unless noProductOnControlledStock and activeProduct.AskForPrice -%}
					<div class="attributes form-js add-to-cart-js need-product-id-js container-js" data-include="add-to-cart">
						<input type="hidden" name="__action" value="Cart/Add" >
						<input type="hidden" name="__template" value="partials/products/add-variants-to-cart.html" >
						<input name="unitId" type="hidden" value="{{ unitId }}">
						{% if config.Products.AIEnabled == true -%}
							<input id="sourceToAdd-js" name="source" type="hidden" value=""/>
						{% endif -%}
							<div class="attributes__wrapper">
								{% if graphicalVariants -%}
									<div class="prices-container">
										{% if customer.HidePrices -%}
											<div class="label sign-in">
												<div class="label__icon">
													<svg width="16" height="19">
														<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#lock-alt-{{settings.iconStyle}}"></use>
													</svg>
												</div>
												<span class="label__text">{{translations.SignInToSeePrice}}</span>
											</div>
											{% if activeProduct.PreviousPrice != null and customer.HidePrices -%}
												{% if customer.Cart.SubtotalPrices -%}
													{% assign whatPrice = translations.Netto | Downcase -%}
													<div class="prices-container__suggested"><span class="value">{{ activeProduct.SubtotalPreviousPrice }} {{ currencyExt }}</span> {{ whatPrice }} - {% if settings.previousPriceAsSuggestedRetailPrice == 'yes' -%} {{translations.SuggestedRetailPrice}} {% else -%} {{translations.PreviousPrice}} {% endif-%}</div>
												{% else -%}
													{% assign whatPrice = translations.Brutto | Downcase -%}
													<div class="prices-container__suggested"><span class="value">{{ activeProduct.TotalPreviousPrice }} {{ currencyExt }}</span> {{ whatPrice }} - {% if settings.previousPriceAsSuggestedRetailPrice == 'yes' -%} {{translations.SuggestedRetailPrice}} {% else -%} {{translations.PreviousPrice}} {% endif-%}</div>
												{% endif -%}
											{% endif -%}
										{% else -%}
											{% if config.ENTERPRISE -%}
												{% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}
													{% if settings.showUnitRateOnProductDetailsPage == 'yes' %}
														{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
															{% if activeProduct.Units[1] and defaultUnit == false and unitId != null -%}
																<div class="prices-container__default-unit-price-container">
																	{{ activeProduct.TotalPrice | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} {{ translations.Brutto | Downcase }}/{{product.SaleUnit}}
																</div>
															{% endif -%}
														{% else -%}
															{% if activeProduct.BasicUnit != unitName -%}
																<div class="prices-container__default-unit-price-container">
																	{{ activeProduct.TotalPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} {{ translations.Brutto | Downcase }}/{{product.BasicUnit}}
																</div>
															{% endif -%}
														{% endif -%}
													{% endif -%}
													<div class="prices-container__price-container">
														<span class="price brutto-js" data-brutto-price="{{activeProduct.TotalPrice | DividedBy: activeProduct.BasicUnitRatio  | Round: config.DecimalPlacesPrice }}">
															{% assign totalPrice = activeProduct.TotalPrice | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
															{% assign totalPriceStr = totalPrice | ToString -%}
															{% assign totalPriceArr = totalPriceStr | Split:config.DecimalSeparator -%}
															{% if totalPriceStr contains config.DecimalSeparator -%}
																{% assign totalPriceDecSize = totalPriceArr[1] | Size | Plus:1 -%}
																{% if totalPriceDecSize <= config.DecimalPlacesPrice -%}
																	{% for i in (totalPriceDecSize..config.DecimalPlacesPrice) -%}
																		{% assign totalPriceStr = totalPriceStr | Append:'0' -%}
																	{% endfor -%}
																	{% assign totalPrice = totalPriceStr -%}
																{% endif -%}
															{% endif -%}
															{{ totalPrice }} {{ currencyExt }}
														</span>
														{% if activeProduct.TotalPreviousPrice > activeProduct.TotalPrice and activeProduct.TotalPreviousPrice != null and settings.previousPriceAsSuggestedRetailPrice != 'yes' -%}
															<span class="previous brutto-previous-js" data-bruttoprevious-price="{{activeProduct.TotalPreviousPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice }}">
																{% assign totalPrevPrice = activeProduct.TotalPreviousPrice | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
																{% assign totalPrevPriceStr = totalPrevPrice | ToString -%}
																{% assign totalPrevPriceArr = totalPrevPriceStr | Split:config.DecimalSeparator -%}
																{% if totalPrevPriceStr contains config.DecimalSeparator -%}
																	{% assign totalPrevPriceDecSize = totalPrevPriceArr[1] | Size | Plus:1 -%}
																	{% if totalPrevPriceDecSize <= config.DecimalPlacesPrice -%}
																		{% for i in (totalPrevPriceDecSize..config.DecimalPlacesPrice) -%}
																			{% assign totalPrevPriceStr = totalPrevPriceStr | Append:'0' -%}
																		{% endfor -%}
																		{% assign totalPrevPrice = totalPrevPriceStr -%}
																	{% endif -%}
																{% endif -%}
																{{ totalPrevPrice }} {{ currencyExt }}
															</span>
														{% elseif activeProduct.TotalRegularPrice > activeProduct.TotalPrice and activeProduct.TotalRegularPrice != null and settings.lowestProductPrice == 'no' -%}
															<span class="previous brutto-previous-js" data-bruttoprevious-price="{{activeProduct.TotalRegularPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice }}">
																{% assign totalPrevPrice = activeProduct.TotalRegularPrice | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
																{% assign totalPrevPriceStr = totalPrevPrice | ToString -%}
																{% assign totalPrevPriceArr = totalPrevPriceStr | Split:config.DecimalSeparator -%}
																{% if totalPrevPriceStr contains config.DecimalSeparator -%}
																	{% assign totalPrevPriceDecSize = totalPrevPriceArr[1] | Size | Plus:1 -%}
																	{% if totalPrevPriceDecSize <= config.DecimalPlacesPrice -%}
																		{% for i in (totalPrevPriceDecSize..config.DecimalPlacesPrice) -%}
																			{% assign totalPrevPriceStr = totalPrevPriceStr | Append:'0' -%}
																		{% endfor -%}
																		{% assign totalPrevPrice = totalPrevPriceStr -%}
																	{% endif -%}
																{% endif -%}
																{{ totalPrevPrice }} {{ currencyExt }}
															</span>
														{% endif -%}
														<span class="label">{{ translations.Brutto | Downcase }}</span>
													</div>
													{% if activeProduct.DepositValue > 0 -%}
														<div class="prices-container__deposit-price">
															<span>+ {{translations.Com_Deposit}}: </span>	
															<span class="deposit-js" data-deposit-price="{{ activeProduct.DepositValue | Times: activeProduct.BasicUnitRatio }}">
																{{ activeProduct.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} / {{ activeProduct.BasicUnit }}
															</span>
														</div>
													{% endif -%}
													{% if settings.lowestProductPrice == 'yes' and activeProduct.MinPrice > 0 and activeProduct.TotalPreviousPrice > activeProduct.TotalPrice and activeProduct.TotalPreviousPrice != null -%}
														<div class="prices-container__lowest-price brutto-lowest-js" data-bruttolowest-price="{{activeProduct.TotalMinPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice }}">
															{% assign totalMinPrice = activeProduct.TotalMinPrice | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
															{% assign totalMinPriceStr = totalMinPrice | ToString -%}
															{% assign totalMinPriceArr = totalMinPriceStr | Split:config.DecimalSeparator -%}
															{% if totalMinPriceStr contains config.DecimalSeparator -%}
																{% assign totalMinPriceDecSize = totalMinPriceArr[1] | Size | Plus:1 -%}
																{% if totalMinPriceDecSize <= config.DecimalPlacesPrice -%}
																	{% for i in (totalMinPriceDecSize..config.DecimalPlacesPrice) -%}
																		{% assign totalMinPriceStr = totalMinPriceStr | Append:'0' -%}
																	{% endfor -%}
																	{% assign totalMinPrice = totalMinPriceStr -%}
																{% endif -%}
															{% endif -%}
															{{ totalMinPrice }} {{ currencyExt }} {{ translations.Brutto | Downcase }} - {{translations.Price_Omnibus}}
														</div>
													{% endif -%}
													{% if activeProduct.TotalPreviousPrice > activeProduct.TotalPrice and activeProduct.TotalPreviousPrice != null and settings.previousPriceAsSuggestedRetailPrice == 'yes' %}
														<div class="prices-container__lowest-price brutto-lowest-js" data-bruttolowest-price="{{activeProduct.TotalPreviousPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice }}">
															{% assign totalPrevPrice = activeProduct.TotalPreviousPrice | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
															{% assign totalPrevPriceStr = totalPrevPrice | ToString -%}
															{% assign totalPrevPriceArr = totalPrevPriceStr | Split:config.DecimalSeparator -%}
															{% if totalPrevPriceStr contains config.DecimalSeparator -%}
																{% assign totalPrevPriceDecSize = totalPrevPriceArr[1] | Size | Plus:1 -%}
																{% if totalPrevPriceDecSize <= config.DecimalPlacesPrice -%}
																	{% for i in (totalPrevPriceDecSize..config.DecimalPlacesPrice) -%}
																		{% assign totalPrevPriceStr = totalPrevPriceStr | Append:'0' -%}
																	{% endfor -%}
																	{% assign totalPrevPrice = totalPrevPriceStr -%}
																{% endif -%}
															{% endif -%}
															{{ totalPrevPrice }} {{ currencyExt }} {{ translations.Brutto | Downcase }} - {{translations.SuggestedRetailPrice}}
														</div>
													{% endif -%}
													{% if settings.showUnitRateOnProductDetailsPage == 'yes' %}
														{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
															{% if activeProduct.Units[1] and defaultUnit == false and unitId != null -%}
																<div class="prices-container__default-unit-price-container">
																	{{ activeProduct.SubtotalPrice | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} {{ translations.Netto | Downcase }}/{{activeProduct.SaleUnit}}
																</div>
															{% endif -%}
														{% else -%}
															{% if activeProduct.BasicUnit != unitName -%}
																<div class="prices-container__default-unit-price-container">
																	{{ activeProduct.SubtotalPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} {{ translations.Netto | Downcase }}/{{activeProduct.BasicUnit}}
																</div>
															{% endif -%}
														{% endif -%}
													{% endif -%}
												{% endunless -%}
												<div class="prices-container__price-container">
													<span class="price netto-js" data-netto-price="{{activeProduct.SubtotalPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice }}">
														{% assign subtotalPrice = activeProduct.SubtotalPrice | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
														{% assign subtotalPriceStr = subtotalPrice | ToString -%}
														{% assign subtotalPriceArr = subtotalPriceStr | Split:config.DecimalSeparator -%}
														{% if subtotalPriceStr contains config.DecimalSeparator -%}
															{% assign subtotalPriceDecSize = subtotalPriceArr[1] | Size | Plus:1 -%}
															{% if subtotalPriceDecSize <= config.DecimalPlacesPrice -%}
																{% for i in (subtotalPriceDecSize..config.DecimalPlacesPrice) -%}
																	{% assign subtotalPriceStr = subtotalPriceStr | Append:'0' -%}
																{% endfor -%}
																{% assign subtotalPrice = subtotalPriceStr -%}
															{% endif -%}
														{% endif -%}
														{{ subtotalPrice }} {{ currencyExt }}
													</span>
													{% if activeProduct.SubtotalPreviousPrice > activeProduct.SubtotalPrice and activeProduct.SubtotalPreviousPrice != null and settings.previousPriceAsSuggestedRetailPrice != 'yes' -%}
														<span class="previous netto-previous-js" data-nettoprevious-price="{{activeProduct.SubtotalPreviousPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice }}">
															{% assign subtotalPrevPrice = activeProduct.SubtotalPreviousPrice | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
															{% assign subtotalPrevPriceStr = subtotalPrevPrice | ToString -%}
															{% assign subtotalPrevPriceArr = subtotalPrevPriceStr | Split:config.DecimalSeparator -%}
															{% if subtotalPrevPriceStr contains config.DecimalSeparator -%}
																{% assign subtotalPrevPriceDecSize = subtotalPrevPriceArr[1] | Size | Plus:1 -%}
																{% if subtotalPrevPriceDecSize <= config.DecimalPlacesPrice -%}
																	{% for i in (subtotalPrevPriceDecSize..config.DecimalPlacesPrice) -%}
																		{% assign subtotalPrevPriceStr = subtotalPrevPriceStr | Append:'0' -%}
																	{% endfor -%}
																	{% assign subtotalPrevPrice = subtotalPrevPriceStr -%}
																{% endif -%}
															{% endif -%}
															{{ subtotalPrevPrice }} {{ currencyExt }}
														</span>
													{% elseif activeProduct.SubtotalRegularPrice > activeProduct.SubtotalPrice and activeProduct.SubtotalRegularPrice != null and settings.lowestProductPrice == 'no' -%}
														<span class="previous netto-previous-js" data-nettoprevious-price="{{activeProduct.SubtotalRegularPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice }}">
															{% assign subtotalPrevPrice = activeProduct.SubtotalRegularPrice | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
															{% assign subtotalPrevPriceStr = subtotalPrevPrice | ToString -%}
															{% assign subtotalPrevPriceArr = subtotalPrevPriceStr | Split:config.DecimalSeparator -%}
															{% if subtotalPrevPriceStr contains config.DecimalSeparator -%}
																{% assign subtotalPrevPriceDecSize = subtotalPrevPriceArr[1] | Size | Plus:1 -%}
																{% if subtotalPrevPriceDecSize <= config.DecimalPlacesPrice -%}
																	{% for i in (subtotalPrevPriceDecSize..config.DecimalPlacesPrice) -%}
																		{% assign subtotalPrevPriceStr = subtotalPrevPriceStr | Append:'0' -%}
																	{% endfor -%}
																	{% assign subtotalPrevPrice = subtotalPrevPriceStr -%}
																{% endif -%}
															{% endif -%}
															{{ subtotalPrevPrice }} {{ currencyExt }}
														</span>
													{% endif -%}
													<span class="label">{{ translations.Netto | Downcase }}</span>
												</div>
												{% if activeProduct.DepositValue > 0 -%}
													<div class="prices-container__deposit-price">
														<span>+ {{translations.Com_Deposit}}: </span>
														<span class="deposit-js" data-deposit-price="{{ activeProduct.DepositValue | Times: supplyProduct.BasicUnitRatio }}">
															{{ activeProduct.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} / {{ activeProduct.BasicUnit }}
														</span>
													</div>
												{% endif -%}
												{% if settings.lowestProductPrice == 'yes' and activeProduct.MinPrice > 0 and activeProduct.SubtotalPreviousPrice > activeProduct.SubtotalPrice and activeProduct.SubtotalPreviousPrice != null -%}
													<div class="prices-container__lowest-price netto-lowest-js" data-nettolowest-price="{{activeProduct.SubtotalMinPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice }}">
														{% assign subtotalMinPrice = activeProduct.SubtotalMinPrice | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
														{% assign subtotalMinPriceStr = subtotalMinPrice | ToString -%}
														{% assign subtotalMinPriceArr = subtotalMinPriceStr | Split:config.DecimalSeparator -%}
														{% if subtotalMinPriceStr contains config.DecimalSeparator -%}
															{% assign subtotalMinPriceDecSize = subtotalMinPriceArr[1] | Size | Plus:1 -%}
															{% if subtotalMinPriceDecSize <= config.DecimalPlacesPrice -%}
																{% for i in (subtotalMinPriceDecSize..config.DecimalPlacesPrice) -%}
																	{% assign subtotalMinPriceStr = subtotalMinPriceStr | Append:'0' -%}
																{% endfor -%}
																{% assign subtotalMinPrice = subtotalMinPriceStr -%}
															{% endif -%}
														{% endif -%}
														{{ subtotalMinPrice }} {{ currencyExt }} {{ translations.Netto | Downcase }} - {{translations.Price_Omnibus}}
													</div>
												{% endif -%}
												{% if activeProduct.SubtotalPreviousPrice > activeProduct.SubtotalPrice and activeProduct.SubtotalPreviousPrice != null and settings.previousPriceAsSuggestedRetailPrice == 'yes' %}
													<div class="prices-container__lowest-price netto-lowest-js" data-netto-lowest="{{activeProduct.SubtotalRegularPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice }}">
														{% assign subtotalPrevPrice = activeProduct.SubtotalRegularPrice | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
														{% assign subtotalPrevPriceStr = subtotalPrevPrice | ToString -%}
														{% assign subtotalPrevPriceArr = subtotalPrevPriceStr | Split:config.DecimalSeparator -%}
														{% if subtotalPrevPriceStr contains config.DecimalSeparator -%}
															{% assign subtotalPrevPriceDecSize = subtotalPrevPriceArr[1] | Size | Plus:1 -%}
															{% if subtotalPrevPriceDecSize <= config.DecimalPlacesPrice -%}
																{% for i in (subtotalPrevPriceDecSize..config.DecimalPlacesPrice) -%}
																	{% assign subtotalPrevPriceStr = subtotalPrevPriceStr | Append:'0' -%}
																{% endfor -%}
																{% assign subtotalPrevPrice = subtotalPrevPriceStr -%}
															{% endif -%}
														{% endif -%}
														{{ subtotalPrevPrice }} {{ currencyExt }} {{ translations.Netto | Downcase }} - {{translations.SuggestedRetailPrice}}
													</div>
												{% endif -%}
											{% else -%}
												{% assign whatPrice = translations.Brutto | Downcase -%}
												{% if customer.Cart.SubtotalPrices -%}
													{% assign whatPrice = translations.Netto | Downcase -%}
												{% endif -%}
												{% if settings.showUnitRateOnProductDetailsPage == 'yes' %}
													{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
														{% if activeProduct.Units[1] and defaultUnit == false and unitId != null -%}
															<div class="prices-container__default-unit-price-container">
																{{ activeProduct.Price | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} {{ whatPrice }}/{{activeProduct.SaleUnit}}
															</div>
														{% endif -%}
													{% else -%}
														{% if activeProduct.BasicUnit != unitName -%}
															<div class="prices-container__default-unit-price-container">
																{{ activeProduct.Price | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} {{ whatPrice }}/{{activeProduct.BasicUnit}}
															</div>
														{% endif -%}
													{% endif -%}
												{% endif -%}
												<div class="prices-container__price-container">
													<span class="price {{whatPrice}}-js" data-{{whatPrice}}-price="{{activeProduct.Price | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice }}">
														{% assign price = activeProduct.Price | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
														{% assign priceStr = price | ToString -%}
														{% assign priceArr = priceStr | Split:config.DecimalSeparator -%}
														{% if priceStr contains config.DecimalSeparator -%}
															{% assign priceDecSize = priceArr[1] | Size | Plus:1 -%}
															{% if priceDecSize <= config.DecimalPlacesPrice -%}
																{% for i in (priceDecSize..config.DecimalPlacesPrice) -%}
																	{% assign priceStr = priceStr | Append:'0' -%}
																{% endfor -%}
																{% assign price = priceStr -%}
															{% endif -%}
														{% endif -%}
														{{ price }} {{ currencyExt }}
													</span>
													{% if activeProduct.PreviousPrice > activeProduct.Price and activeProduct.PreviousPrice != null and settings.previousPriceAsSuggestedRetailPrice != 'yes' -%}
														<span class="previous {{whatPrice}}-previous-js" data-{{whatPrice}}previous="{{activeProduct.PreviousPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice }}">
															{% assign prevPrice = activeProduct.PreviousPrice | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
															{% assign prevPriceStr = prevPrice | ToString -%}
															{% assign prevPriceArr = prevPriceStr | Split:config.DecimalSeparator -%}
															{% if prevPriceStr contains config.DecimalSeparator -%}
																{% assign prevPriceDecSize = prevPriceArr[1] | Size | Plus:1 -%}
																{% if prevPriceDecSize <= config.DecimalPlacesPrice -%}
																	{% for i in (prevPriceDecSize..config.DecimalPlacesPrice) -%}
																		{% assign prevPriceStr = prevPriceStr | Append:'0' -%}
																	{% endfor -%}
																	{% assign prevPrice = prevPriceStr -%}
																{% endif -%}
															{% endif -%}
															{{ prevPrice }} {{ currencyExt }}
														</span>
													{% endif -%}
													<span class="label">{{ whatPrice }}</span>
												</div>
												{% if settings.lowestProductPrice == 'yes' and activeProduct.MinPrice > 0 and activeProduct.PreviousPrice > activeProduct.Price and activeProduct.PreviousPrice != null -%}
													<div class="prices-container__lowest-price {{ whatPrice }}-lowest-js" data-{{ whatPrice }}lowest-price="{{activeProduct.MinPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice }}">
														{% assign minPrice = activeProduct.MinPrice | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
														{% assign minPriceStr = minPrice | ToString -%}
														{% assign minPriceArr = minPriceStr | Split:config.DecimalSeparator -%}
														{% if minPriceStr contains config.DecimalSeparator -%}
															{% assign minPriceDecSize = minPriceArr[1] | Size | Plus:1 -%}
															{% if minPriceDecSize <= config.DecimalPlacesPrice -%}
																{% for i in (minPriceDecSize..config.DecimalPlacesPrice) -%}
																	{% assign minPriceStr = minPriceStr | Append:'0' -%}
																{% endfor -%}
																{% assign minPrice = minPriceStr -%}
															{% endif -%}
														{% endif -%}
														{{ minPrice }} {{ currencyExt }} {{ whatPrice }} - {{translations.Price_Omnibus}}
													</div>
												{% endif -%}
												{% if activeProduct.PreviousPrice > activeProduct.Price and activeProduct.PreviousPrice != null and settings.previousPriceAsSuggestedRetailPrice == 'yes' %}
													{% assign prevPrice = activeProduct.PreviousPrice | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
													{% assign prevPriceStr = prevPrice | ToString -%}
													{% assign prevPriceArr = prevPriceStr | Split:config.DecimalSeparator -%}
													{% if prevPriceStr contains config.DecimalSeparator -%}
														{% assign prevPriceDecSize = prevPriceArr[1] | Size | Plus:1 -%}
														{% if prevPriceDecSize <= config.DecimalPlacesPrice -%}
															{% for i in (prevPriceDecSize..config.DecimalPlacesPrice) -%}
																{% assign prevPriceStr = prevPriceStr | Append:'0' -%}
															{% endfor -%}
															{% assign prevPrice = prevPriceStr -%}
														{% endif -%}
													{% endif -%}
													<div class="prices-container__lowest-price {{ whatPrice }}-lowest-js" data-{{ whatPrice }}lowest-price="{{activeProduct.PreviousPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice}}">
														{{ prevPrice }} {{ currencyExt }} {{ whatPrice }} - {{translations.SuggestedRetailPrice}}
													</div>
												{% endif -%}
											{% endif -%}
											{% if activeProduct.UnitPriceUnit != null -%}
												<div class="prices-container__unit-price">
													{{ activeProduct.Price | Times: activeProduct.UnitPriceRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} {% if customer.Cart.SubtotalPrices -%}{{ translations.Netto | Downcase }}{% else -%}{{ translations.Brutto | Downcase }}{% endif -%}/{{ activeProduct.UnitPriceUnit }}
												</div>
											{% endif -%}
										{% endif -%}
									</div>
								{% endif -%}				

								{% if product.Clip or product.Batch -%}
									{% if graphicalVariants == true -%}
										{% assign supplies = product.Supplies.Supplies -%}
										{% assign suppliesSize = product.Supplies.Supplies | Size -%}

										{% if suppliesSize > 0 -%}
											{% assign levelsQuantity = product.Supplies.AttributeNames | Size -%}
											{% assign firstLevelName = product.Supplies.AttributeNames[0].Name -%}

											{% comment -%}<!-- Render level zero with images, show first image of the subtree -->{% endcomment -%}
											<div class="graphical-variants__container">

												{% comment -%}<!-- Name of current selected value -->{% endcomment -%}
												{% assign key = keys[0] -%}
												{% for firstLevelSupply in supplies -%}
													{% if firstLevelSupply.ValueId == key -%}
														{% assign firstLevelValue = firstLevelSupply.Value -%}
													{% endif -%}
												{% endfor -%}
												<p class="name">{{ firstLevelName }}: <span class="value">{{firstLevelValue}}</span></p>
												<div class="graphical-variants graphical-variants-js">
													{% for firstLevelSupply in supplies -%}
														{% comment -%}
															<!-- Recursive get the first available child product (for image rendering on the first level) -->
															<!-- Returns: foundProduct and dataKeys -->
														{% endcomment -%}

														{% include 'partials/product/find-variant-product.html' with currentSupply: firstLevelSupply, depth: 1, maxDepth: levelsQuantity -%}

														{% assign noSupplyProductOnControlledStock = false -%}
														{% if supplyStockLevel.QuantityControl == true and supplyStockLevel.Value == 0 -%}
															{% assign noSupplyProductOnControlledStock = true -%}
														{% else -%}
															{% assign noSupplyProductOnControlledStock = false -%}
														{% endif -%}

														<div class="graphical-variant graphical-variant-js change-variant-on-products-list-js value {% if forloop.index > graphicalVariantsLimit and checked == false -%} hidden-js {% endif -%} {% if firstLevelSupply.ValueId == key -%} active-js {% endif -%} parent-container-reload-js {% if levelsQuantity != 1 %} {% else -%} child-js  {% endif -%} {% if noSupplyProductOnControlledStock or foundProduct.Availability.Status == 3 -%} unavailable {% endif -%} {% if foundProduct.AskForPrice or noSupplyProductOnControlledStock or foundProduct.Availability.Status == 3 -%} ask-for-price-child-js {% endif -%} {% if foundProduct.AttributesEditable[0] or foundProduct.AttributesPolyvalent[0] -%} with-attributes {% endif -%}" data-url="{{ url }}?keys={{ dataKeys }}{% if unitId != null -%}&unit={{ unitId }}{% endif -%}" {% if levelsQuantity == 1 %} data-child-index="{{ forloop.index0 }}" data-supply-id="{{ firstLevelSupply.SupplyId }}" data-img="http:{{ page.BaseHref }}img/large/{{ foundProduct.ImageId }}/.jpg" data-code="{{ foundProduct.Code }}" data-weight="{{ foundProduct.Weight }}" data-netweight="{{ foundProduct.NetWeight}}" {% endif -%}>
															{% if settings.grapicalVariantsPresentation == 'Variants_Colors' -%}
																{% assign anyColor = false -%}
																{% for firstLevelSupply in supplies -%}
																	{% for color in colorVariants -%}
																		{% assign colorArr = color | Split: '||' -%}

																		{%comment %} <!-- Case-insensitive comparison --> {% endcomment -%}
																		{% assign valueDowncase = firstLevelSupply.Value | Downcase -%}
																		{% assign colorDowncase = colorArr[0] | Downcase -%}
																		
																		{% if colorDowncase == valueDowncase -%}
																			{% assign anyColor = true -%}
																			{% break -%}
																		{% endif -%}
																	{% endfor -%}
																{% endfor -%}
															
																{% assign colorHex = '#FFFFFF' -%}
																{% for color in colorVariants -%}
																	{% assign colorArr = color | Split: '||' -%}

																	{%comment %} <!-- Case-insensitive comparison --> {% endcomment -%}
																	{% assign valueDowncase = firstLevelSupply.Value | Downcase -%}
																	{% assign colorDowncase = colorArr[0] | Downcase -%}

																	{% if colorDowncase == valueDowncase -%}
																		{% assign colorHex = colorArr[1] -%}
																		{% break -%}
																	{% endif -%}
																{% endfor -%}

																{% comment %} <!-- Color representation --> {% endcomment %}
																<label tabindex="0" class="chip {% if anyColor -%} chip--color {% else -%} chip--default {% endif -%}">
																	<input tabindex="-1" type="radio" name="attributeId" value="{{firstLevelSupply.ValueId}}" {% if firstLevelSupply.ValueId == key -%} checked {% endif -%}>
																	{% if anyColor -%}
																		<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
																			{% if colorHex == 'multicolor' %}
																				<foreignObject x="4" y="4" width="32" height="32">
																					<div xmlns="http://www.w3.org/1999/xhtml" class="multicolor"></div>
																				</foreignObject>
																			{% else %}
																				<circle cx="20" cy="20" r="16" fill="{{ colorHex }}" {% if colorHex == '#FFFFFF' %} stroke="black" stroke-width="0.25"{% endif %}/>
																			{% endif %}
																		</svg>
																	{% else -%}
																		{{firstLevelSupply.Value}}
																	{% endif -%}
																</label>
															{% elseif settings.grapicalVariantsPresentation == 'Variants_Thumbnails' -%}
																{% comment %} <!-- Thumbnail representation --> {% endcomment %}
																<label tabindex="0" class="chip chip--thumbnail">
																	<input tabindex="-1" type="radio" name="attributeId" value="{{ firstLevelSupply.ValueId }}" {% if firstLevelSupply.ValueId == key -%} checked {% endif -%}>
																		{% if firstLevelSupply.ValueId == key and activeProduct.Image -%}
																			{{activeProduct | Img }}
																		{% elseif foundProduct.Image -%}
																			{{ foundProduct | Img }}
																		{% else -%}
																			<img width="52" height="52" src="css/img/img-placeholder.jpg" alt="{{translations.DefaultImage}}"/>
																		{% endif -%}
																</label>
															{% elseif settings.grapicalVariantsPresentation == 'Variants_DropDownList' -%}
																{% comment %} <!-- Normal chip --> {% endcomment %}
																<label tabindex="0" class="chip chip--default">
																	<input tabindex="-1" type="radio" name="attributeId" value="{{ firstLevelSupply.ValueId }}" {% if firstLevelSupply.ValueId == key -%} checked {% endif -%}>
																	{{firstLevelSupply.Value}}
																</label>
															{% endif -%}

															{% if firstLevelSupply.ValueId == key -%}
																{% assign activeSupplies = firstLevelSupply.Supplies -%}
																{% if dataKeys == joinedKeys and levelsQuantity == 1  -%}
																	<input name="supplyId" type="hidden" value="{{ firstLevelSupply.SupplyId }}">
																	{% for keyVal in keys -%}
																		<input name="attributeId" type="hidden" value="{{ keyVal }}" data-key="{{ keyVal }}">
																	{% endfor -%}
																{% endif -%}
															{% endif -%}
														</div>
													{% endfor -%}
													{% assign showMoreCount = suppliesSize | Minus: graphicalVariantsLimit -%}
													{% if showMoreCount > 0 -%}
														<label role="button" tabindex="0" class="open-variants-on-popup-js pure-button chip chip--showMore">
															<input name="showMore" tabindex="-1" type="checkbox" data-count="{{ showMoreCount }}" {% if checked -%} checked {% endif -%}>
															<span class="more">{{translations.More}} +{{ showMoreCount }}</span>
															<span class="less">{{translations.Less}}</span>
														</label>
													{% endif -%}
												</div>

												{% comment -%}<!-- Render the rest of the tree from the first level -->{% endcomment -%}
												{% assign otherLevels = product.Supplies.AttributeNames | Skip: 1 %}
												{% assign levelsQuantity = levelsQuantity | Minus: 1 -%}
												{% assign supplies = activeSupplies -%}

												{% for attribute in otherLevels -%}
													{% assign lvl = forloop.index -%}
													{% if lvl != levelsQuantity -%}
														<div class="attributes__not-last-level-attribute">
															{% comment -%}<!-- Level name -->{% endcomment -%}
															<div class="name">{{ attribute.Name }}</div>

															{% comment -%}<!-- Level values-->{% endcomment -%}
															<div class="values">
																{% assign key = keys[forloop.index] -%}
																
																{% for supply in supplies -%}
																	{% if supply.Key -%}
																		{% assign dataKeys = supply.Key -%}
																	{% else -%}
																		{% assign childs = supply.Supplies -%}
																		{% assign size = keys | Size -%}
																		{% assign end = size | Minus: lvl -%}
																		{% for lvl in (1..end) -%}
																			{% for child in childs -%}
																				{% if child.ValueId == childs[0].ValueId -%}
																					{% unless child.Key -%}
																						{% assign childs = child.Supplies -%}
																					{% else -%}
																						{% assign dataKeys = child.Key -%}
																					{% endunless -%}
																					{% break -%}
																				{% endif -%}
																			{% endfor -%}
																		{% endfor -%}
																	{% endif -%}

																	<button class="value {% if supply.ValueId == key -%} active-js {% endif -%} change-variant-on-products-list-js parent-container-reload-js" data-url="{{ url }}?keys={{ dataKeys }}{% if unitId != null -%}&unit={{ unitId }}{% endif -%}">
																		{{ supply.Value }}

																		{% if supply.ValueId == key -%}
																			{% assign supplies = supply.Supplies -%}
																			{% if supply.Key == joinedKeys -%}
																				<input name="supplyId" type="hidden" value="{{ supply.SupplyId }}" data-supply="{{ supply.SupplyId }}">
																				{% for keyVal in keys -%}
																					<input name="attributeId" type="hidden" value="{{ keyVal }}" data-key="{{ keyVal }}">
																				{% endfor -%}
																			{% endif -%}
																		{% endif -%}
																	</button>
																{% endfor -%}
															</div>
														</div>
													{% else -%}
														<div class="attributes__not-last-level-attribute">
															{% comment -%}<!-- Last level name -->{% endcomment -%}
															<div class="name">{{ attribute.Name }}</div>

															{% comment -%}<!-- Last level values-->{% endcomment -%}
															<div class="values">
																{% assign key = keys[forloop.index] -%}
																
																{% for supply in supplies -%}
																	{% if supply.Key -%}
																		{% assign dataKeys = supply.Key -%}
																	{% else -%}
																		{% assign childs = supply.Supplies -%}
																		{% assign size = keys | Size -%}
																		{% assign end = size | Minus: lvl -%}
																		{% for lvl in (1..end) -%}
																			{% for child in childs -%}
																				{% if child.ValueId == childs[0].ValueId -%}
																					{% unless child.Key -%}
																						{% assign childs = child.Supplies -%}
																					{% else -%}
																						{% assign dataKeys = child.Key -%}
																					{% endunless -%}
																					{% break -%}
																				{% endif -%}
																			{% endfor -%}
																		{% endfor -%}
																	{% endif -%}

																	{% if product.Clip -%}
																		{% assign supplyProduct = supply.Product -%}
																	{% elseif product.Batch -%}
																		{% assign supplyProduct = product -%}
																	{% endif -%}

																	{% for unit in supplyProduct.Units -%}
																		{% if unit.Default == true or unit.Id == null -%}
																			{% assign supplyUnitId = unit.Id -%}
																			{% assign supplyUnitRatio = unit.Ratio -%}
																			{% assign supplyUnitName = unit.Name -%}
																			{% assign defaultSupplyUnit = unit.Default -%}
																		{% endif -%}
																	{% endfor -%}

																	{% assign supplyStockLevel = supply.StockLevel -%}
																	{% assign noSupplyProductOnControlledStock = false -%}
																	{% if supplyProduct.StockLevel.QuantityControl == true and supplyProduct.StockLevel.Value == 0 -%}
																		{% assign noSupplyProductOnControlledStock = true -%}
																	{% else -%}
																		{% assign noSupplyProductOnControlledStock = false -%}
																	{% endif -%}

																	<button class="value {% if supply.ValueId == key -%} active-js {% endif -%} change-variant-on-products-list-js {% if noSupplyProductOnControlledStock or supplyProduct.Availability.Status == 3 -%} unavailable {% endif -%} child-js parent-container-reload-js {% if supplyProduct.AskForPrice or noSupplyProductOnControlledStock or supplyProduct.Availability.Status == 3 -%} ask-for-price-child-js {% endif -%} {% if supplyProduct.AttributesEditable[0] or supplyProduct.AttributesPolyvalent[0] -%} with-attributes {% endif -%}" data-url="{{ url }}?keys={{ dataKeys }}{% if unitId != null -%}&unit={{ unitId }}{% endif -%}" data-child-index="{{ forloop.index0 }}" data-supply-id="{{ supply.SupplyId }}" data-img="http:{{ page.BaseHref }}img/large/{{ supplyProduct.ImageId }}/.jpg" data-code="{{ supplyProduct.Code }}" data-weight="{{ supplyProduct.Weight }}" data-netweight="{{ supplyProduct.NetWeight}}">
																		{{ supply.Value }}

																		{% if supply.ValueId == key -%}
																			{% assign supplies = supply.Supplies -%}
																			{% if supply.Key == joinedKeys -%}
																				<input name="supplyId" type="hidden" value="{{ supply.SupplyId }}" data-supply="{{ supply.SupplyId }}">
																				{% for keyVal in keys -%}
																					<input name="attributeId" type="hidden" value="{{ keyVal }}" data-key="{{keyVal}}">
																				{% endfor -%}
																			{% endif -%}
																		{% endif -%}
																	</button>
																{% endfor -%}
															</div>
														</div>
													{% endif -%}
												{% endfor -%}	

												{% comment -%} <!-- Attributes editable and polyvalent --> {% endcomment -%}
												{% if activeProduct.AttributesEditable[0] or activeProduct.AttributesPolyvalent[0] -%}
													<div class="graphical-variants__attributes attributes-container-js">
														<div class="last-level-attribute__more-attributes">
															<div class="attr-container">
																{% if activeProduct.AttributesEditable[0] -%}
																	{% for attrEditable in activeProduct.AttributesEditable -%}
																		<div class="attribute-editable attribute-container-js">
																			<input name="attributeId" type="hidden" value="{{ attrEditable.Id }}">
																			<div class="form__input-wrapper">
																				{% case attrEditable.Format -%}
																					{% when 1 -%}
																						<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js">{{ attrEditable.Name }}</label>
																						<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="text" name="attributeEditable" value="" maxlength="50" >
																						<div class="form__input-value--clear-button">
																							<svg width="16" height="16">
																								<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
																							</svg>
																						</div>	
																					{% when 2 -%}
																						<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js">{{ attrEditable.Name }}</label>
																						<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="number" name="attributeEditable" value="" max="999999999999999" >
																					{% when 3 -%}
																						<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js on-label">{{ attrEditable.Name }}</label>
																						<div tabindex="0" class="select select-js">
																							<select id="attribute-edit-{{forloop.index}}" class="memory-js" name="attributeEditable">
																								{% for val in attrEditable.Values %}
																									<option value="{{ val.ValueId }}">{{ val.Value }}</option>
																								{% endfor -%}
																							</select>
																							<div class="select__input">
																								<span class="selected-js" title="{{ attrEditable.Values[0].Value }}">
																									{{ attrEditable.Values[0].Value }}
																								</span>
																								<svg width="16" height="16">
																									<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
																								</svg>
																							</div>
																							<ul class="select__options options-js">
																								{% for val in attrEditable.Values %}
																									<li tabindex="-1" data-value="{{ val.ValueId }}">{{ val.Value }}</li>
																								{% endfor -%}
																							</ul>
																						</div>
																					{% when 4 -%}
																						<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js on-label">{{ attrEditable.Name }}</label>
																						<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="date" name="attributeEditable" value="" >
																				{% endcase -%}
																				<div class="form__invalid-input validation-info-js validation-required-js hidden-js">
																					{{ translations.FillAttributeValue }}
																				</div>
																			</div>
																		</div>
																	{% endfor -%}
																{% endif -%}
																{% if activeProduct.AttributesPolyvalent[0] -%}
																	{% for attrPolyvalent in activeProduct.AttributesPolyvalent -%}
																		<div class="attribute-editable attribute-container-js">
																			<div class="form__input-wrapper">
																				<span class="form__input-info input-info-js on-label">{{ attrPolyvalent.Name }}</span>
																				<div tabindex="0" class="select select-js">
																					<select aria-label="{{ attrPolyvalent.Name }}" class="memory-js" name="attributePolyvalent">
																						{% for val in attrPolyvalent.Values %}
																							<option value="{{ val.ValueId }}">{{ val.Value }}</option>
																						{% endfor -%}
																					</select>
																					<div class="select__input">
																						<span class="selected-js" title="{{ attrPolyvalent.Values[0].Value }}">
																							{{ attrPolyvalent.Values[0].Value }}
																						</span>
																						<svg width="16" height="16">
																							<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
																						</svg>
																					</div>
																					<ul class="select__options options-js">
																						{% for val in attrPolyvalent.Values %}
																							<li tabindex="-1" data-name="attributePolyvalent" data-value="{{ val.ValueId }}">{{ val.Value }}</li>
																						{% endfor -%}
																					</ul>
																				</div>
																				<div class="form__invalid-input validation-info-js validation-required-js hidden-js">
																					{{ translations.FillAttributeValue }}
																				</div>
																			</div>
																		</div>
																	{% endfor -%}
																{% endif -%}
															</div>
														</div>
													</div>
												{% endif -%}

												{% comment -%} <!-- Quantity and Unit --> {% endcomment -%}
												{% for unit in activeProduct.Units -%}
													{% if unit.Default == true or unit.Id == null -%}
														{% assign activeProductUnitId = unit.Id -%}
														{% assign activeProductUnitRatio = unit.Ratio -%}
														{% assign activeProductUnitName = unit.Name -%}
														{% assign defaultSupplyUnit = unit.Default -%}
													{% endif -%}
												{% endfor -%}

												{% if noSupplyProductOnControlledStock == false and activeProduct.AskForPrice == false and activeProduct.Availability.Status != 3 -%}
													<div class="graphical-variants__quantity-unit">
														<div class="quantity-column graphical-variants__quantity ammount-stepper-js" data-quantity="{% if config.Products.DecimalUnits -%}0{{ config.DecimalSeparator }}00{% else -%}0{% endif -%}" {% if activeProduct.StockLevel != null and activeProduct.StockLevel.QuantityControl and showStock -%} data-stock-value="{{ activeProduct.StockLevel.Value | Normalize }}" data-basic-unit="{{ activeProduct.BasicUnitRatio }}" {% endif -%} data-supply-id="{{activeProduct.Id}}">
															{% if product.Clip -%}
																{% include 'partials/product/amount-stepper.html' with activeProduct -%}
															{% elseif product.Batch -%}
																{% include 'partials/product/amount-stepper.html' with activeProduct.StockLevel -%}
															{% endif -%}

															{% assign unitRatioInfo = false -%}
															{% if settings.showUnitRateOnProductDetailsPage == 'yes' and settings.showUnitRateOnProductDetailsPageUnit == 'basic' and activeProductUnitName != activeProduct.BasicUnit -%}
																{% assign unitRatioInfo = true -%}
															{% endif -%}
														</div>
														<div class="unit-column graphical-variants__unit unit-ratio-js" data-unit="{{ unitId }}" data-unit-ratio-info="{{unitRatioInfo}}" data-basic-unit-ratio="{{activeProduct.BasicUnitRatio}}">
															{% if activeProduct.Units[1] -%}
																<div tabindex="0" class="unit-column__units select select-js child-select-js">
																	<select id="unit-select-{{ activeProduct.Id }}" class="memory-js" data-index="0" aria-label="{{ translations.Unit }}">
																		{% for unit in activeProduct.Units -%}
																			{% if unit.Id == unitId -%}
																				{% assign defaultUnitName = unit.Name -%}
																			{% endif -%}
																			<option value="{{ unit.Id }}" {% if unit.Id == activeProductUnitId -%} selected {% endif -%}>{{ unit.Name | H }}</option>
																		{% endfor -%}
																	</select>
																	<div class="select__input">
																		<span class="selected-js">
																			{{ defaultUnitName | H }}
																		</span>
																		<svg>
																			<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
																		</svg>
																	</div>
																	<ul class="select__options options-js units-in-table-js">
																		{% for unit in activeProduct.Units -%}
																			<li tabindex="-1" data-ratio="{{ unit.Ratio }}" data-value="{{ unit.Id }}" {% if unit.Multiplicity > 0 -%} data-multiplicity="{{ unit.Multiplicity }}" {% endif -%}>{{ unit.Name | H }}</li>
																		{% endfor -%}
																	</ul>
																	<input id="unit-dimensions-{{ activeProduct.Id }}" class="dimensions-js" type="hidden"
																	{% for unit in activeProduct.Units -%}
																		{% assign dimensionsByUnitIndex = unit.Dimensions  -%}
																		data-unit{{unit.Id}}="{{dimensionsByUnitIndex.Height}}|{{dimensionsByUnitIndex.Length}}|{{dimensionsByUnitIndex.Width}}"
																	{% endfor -%}>
																</div>
																<div class="unit-column__unit-ratio-info">
																	{% if settings.showUnitRateOnProductDetailsPage == 'yes' -%}
																		{% assign productUnitsSize = activeProduct.Units | Size -%}
																		{% for unit in activeProduct.Units -%}
																			{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																				{% if unit.Id != activeProductUnitId -%}
																					<span class="unit-ratio-info-js {% if productUnitsSize > 1 -%} hidden-js {% endif -%}" data-id="{{unit.Id}}">{{ unit.Ratio | DividedBy: activeProductUnitRatio | Round: 4 }} {{ activeProductUnitName }}</span>
																				{% endif -%}
																			{% else -%}
																				{% if unit.Name != activeProduct.BasicUnit -%}
																					<span class="unit-ratio-info-js {% if productUnitsSize > 1 -%} hidden-js {% endif -%}" data-id="{{unit.Id}}">{{unit.Ratio | Round: 4}} {{activeProduct.BasicUnit}}</span>
																				{% endif -%}
																			{% endif -%}
																		{% endfor -%}
																	{% endif -%}
																</div>
															{% else -%}
																{{ activeProductUnitName }}
															{% endif -%}
															{% if activeProduct.BasicUnitMinQuantity > 1 -%}
																<div class="min-quantity-info">
																	<svg>
																		<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#exclamation-triangle-{{settings.iconStyle}}'></use>
																	</svg>
																	<span>
																		{{ translations.FillProperMinQuantity }} <strong>{{ activeProduct.BasicUnitMinQuantity | Round }} {{ activeProduct.BasicUnit }}</strong>
																	</span>
																</div>
															{% endif -%}
														</div>
													</div>
												{% endif -%}
											</div>
										{% endif -%}
									{% else -%}
										{% assign supplies = product.Supplies.Supplies -%}
										{% assign suppliesSize = product.Supplies.Supplies | Size -%}
										{% if suppliesSize > 0 -%}
											{% for attribute in product.Supplies.AttributeNames -%}
												{% assign lvl = forloop.index -%}
												{% assign levelsQuantity = product.Supplies.AttributeNames | Size -%}
												{% if lvl != levelsQuantity -%}
													<div class="attributes__not-last-level-attribute">
														<div class="name">{{ attribute.Name }}</div>
														<div class="values">
															{% assign key = keys[forloop.index0] -%}
															{% for supply in supplies -%}
																{% if supply.Key -%}
																	{% assign dataKeys = supply.Key -%}
																{% else -%}
																	{% assign childs = supply.Supplies -%}
																	{% assign size = keys | Size -%}
																	{% assign end = size | Minus: lvl -%}
																	{% for lvl in (1..end) -%}
																		{% for child in childs -%}
																			{% if child.ValueId == childs[0].ValueId -%}
																				{% unless child.Key -%}
																					{% assign childs = child.Supplies -%}
																				{% else -%}
																					{% assign dataKeys = child.Key -%}
																				{% endunless -%}
																				{% break -%}
																			{% endif -%}
																		{% endfor -%}
																	{% endfor -%}
																{% endif -%}
																<button aria-label="attribute-button" class="value {% if supply.ValueId == key -%} active-js {% endif -%} parent-container-reload-js change-variant-on-products-list-js" data-url="{{ url }}?keys={{ dataKeys }}{% if unitId != null -%}&unit={{ unitId }}{% endif -%}">
																	{{ supply.Value }}
																</button>
																{% if supply.ValueId == key -%}
																	{% assign supplies = supply.Supplies -%}
																	{% if supply.Key == joinedKeys -%}
																		<input name="supplyId" type="hidden" value="{{ supply.SupplyId }}">
																		{% for keyVal in keys -%}
																			<input name="attributeId" type="hidden" value="{{ keyVal }}">
																		{% endfor -%}
																	{% endif -%}
																{% endif -%}
															{% endfor -%}
														</div>
													</div>
												{% else -%}
													<div class="attributes__table-container">
														<table>
															<thead>
																<tr>
																	<th class="name-column attribute-name-js">{{ attribute.Name }}</th>
																	{% if config.ENTERPRISE -%}
																		<th class="netto-price-column">{{ translations.SubtotalPrice }}</th>
																		<th class="brutto-price-column">{% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}{{ translations.TotalPrice }}{% endunless -%}</th>
																	{% else -%}
																		{% if customer.Cart.SubtotalPrices -%}
																			<th class="netto-price-column">{{ translations.SubtotalPrice }}</th>
																		{% else -%}
																			<th class="brutto-price-column">{{ translations.TotalPrice }}</th>
																		{% endif -%}
																	{% endif -%}
																	{% if product.StockLevel != null and showStock -%}
																		<th class="stock-column">{{ translations.Stock }}</th>
																	{% endif -%}
																	<th class="quantity-column">{{ translations.Quantity }}</th>
																	<th class="unit-column">{{ translations.Unit }}</th>
																</tr>
															</thead>
															<tbody>
																{% assign key = keys[forloop.index0] -%}
																{% for supply in supplies -%}
																	{% if supply.Key -%}
																		{% assign dataKeys = supply.Key -%}
																	{% else -%}
																		{% assign childs = supply.Supplies -%}
																		{% assign size = keys | Size -%}
																		{% assign end = size | Minus: lvl -%}
																		{% for lvl in (1..end) -%}
																			{% for child in childs -%}
																				{% if child.ValueId == childs[0].ValueId -%}
																					{% unless child.Key -%}
																						{% assign childs = child.Supplies -%}
																					{% else -%}
																						{% assign dataKeys = child.Key -%}
																					{% endunless -%}
																					{% break -%}
																				{% endif -%}
																			{% endfor -%}
																		{% endfor -%}
																	{% endif -%}

																	{% if product.Clip -%}
																		{% assign supplyProduct = supply.Product -%}
																	{% elseif product.Batch -%}
																		{% assign supplyProduct = product -%}
																	{% endif -%}

																	{% assign supplyStockLevel = supply.StockLevel -%}

																	{% for unit in supplyProduct.Units -%}
																		{% if unit.Default == true or unit.Id == null -%}
																			{% assign supplyUnitId = unit.Id -%}
																			{% assign supplyUnitRatio = unit.Ratio -%}
																			{% assign supplyUnitName = unit.Name -%}
																			{% assign defaultSupplyUnit = unit.Default -%}
																		{% endif -%}
																	{% endfor -%}

																	{% if supplyProduct.StockLevel.QuantityControl == true and supplyProduct.StockLevel.Value == 0 -%}
																		{% assign noSupplyProductOnControlledStock = true -%}
																	{% else -%}
																		{% assign noSupplyProductOnControlledStock = false -%}
																	{% endif -%}
																<tr class="last-level-attribute {% if supply.ValueId == key -%} active-js {% endif -%} {% if noSupplyProductOnControlledStock or supplyProduct.Availability.Status == 3 -%} unavailable {% endif -%} child-js {% if supplyProduct.AskForPrice or noSupplyProductOnControlledStock or supplyProduct.Availability.Status == 3 -%} ask-for-price-child-js {% endif -%} {% if supplyProduct.AttributesEditable[0] or supplyProduct.AttributesPolyvalent[0] -%} with-attributes expandable-mechanism-container-js {% endif -%}" data-url="{{ url }}?keys={{ dataKeys }}{% if unitId != null -%}&unit={{ unitId }}{% endif -%}" data-child-index="{{ forloop.index0 }}" data-supply-id="{{ supply.SupplyId }}" data-img="http:{{ page.BaseHref }}img/large/{{ supplyProduct.ImageId }}/.jpg" data-code="{{ supplyProduct.Code | H }}" data-weight="{{ supplyProduct.Weight }}" data-netweight="{{ supplyProduct.NetWeight}}">
																	<td class="name-column supply-value-js">
																		{{ supply.Value }}
																		{% if supplyProduct.AskForPrice == false -%}
																			{% if noSupplyProductOnControlledStock == false and supplyProduct.Availability.Status != 3 -%}
																				{% if supplyProduct.AttributesEditable[0] or supplyProduct.AttributesPolyvalent[0] -%}
																					<button class="pure-button expand-data-js change-arrow-title-js" title="{{ translations.ShowDetails }}">
																						{{ translations.ShowDetails }} 
																						<svg height="16" width="16" class="icon rotate-down dropdown-arrow">
																							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
																						</svg>
																					</button>
																				{% endif -%}
																			{% endif -%}
																		{% endif -%}
																	</td>
																		{% assign supplyUnitsSize = supplyProduct.Units | Size -%}
																		{% if settings.thresholds == 'yes' and supplyProduct.HasThresholds and supplyProduct.Price != null and supplyUnitsSize == 1 -%}
																			<td class="thresholds-column" {% if config.ENTERPRISE -%} colspan="2" {% endif -%}>
																				{% assign whatPrice = translations.Brutto | Downcase -%}
																				{% if customer.Cart.SubtotalPrices -%}
																					{% assign whatPrice = translations.Netto | Downcase -%}
																				{% endif -%}
																				{% assign firstThreshold = supplyProduct.Thresholds | First -%}
																				{% assign lastThreshold = supplyProduct.Thresholds | Last -%}
																				<div class="thresholds-column__label">{{ translations.Price }} {{ whatPrice }}</div>
																				<div class="thresholds-column__range">
																					{{ translations.RangeFrom | Downcase }} <strong>{{ lastThreshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}</strong> {{ translations.RangeTo | Downcase }} {{ firstThreshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}
																				</div>
																				{% assign thresholdsSize = supplyProduct.Thresholds | Size -%}
																				{% if thresholdsSize >= 2 -%}
																					<button class="thresholds-column__open-thresholds-popup pure-button open-next-element-js stop-propagation-js">
																					<span>{{ translations.SeePriceDetails }}</span>
																					</button>
																					<div class="popup-background hidden-js hide-js container-to-hide-js">
																						<div class="popup thresholds-popup">
																							<div class="popup__header">
																								<div class="title">{{ translations.PriceDetails }}</div>
																								<svg class="hide-container-js">
																									<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
																								</svg>
																							</div>
																							<div class="popup__content">
																								<div class="name">{{ supplyProduct.Name }}</div>
																								<div class="thresholds">
																									<div class="thresholds__row">
																										<span>{{ translations.Quantity }} [{{ supplyUnitName }}]:</span>
																										<span>{{ translations.Price }} {{ whatPrice }}:</span>
																									</div>
																									{% for threshold in supplyProduct.Thresholds -%}
																										<div class="thresholds__row">
																											<div>{{ threshold.Threshold | Normalize }}+</div>
																											<div>{{ threshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}</div>
																										</div>
																									{% endfor %}
																								</div>
																							</div>
																						</div>
																					</div>
																				{% endif -%}
																			</td>
																		{% elseif config.ENTERPRISE -%}
																			<td class="netto-price-column" data-netto-price="{{ supplyProduct.SubtotalPrice | DividedBy: supplyProduct.BasicUnitRatio }}">
																				{% if supplyProduct.SubtotalPrice != null -%}
																					<span class="netto-price-column__price">
																						<span class="netto-js">
																							{{ supplyProduct.SubtotalPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }}
																						</span>
																						<span class="price">{{ currencyExt }}</span>
																						{% if supplyProduct.SubtotalPreviousPrice != null and supplyProduct.SubtotalPreviousPrice > supplyProduct.SubtotalPrice -%}
																							<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																							{% if settings.previousPriceAsSuggestedRetailPrice == 'yes' %}
																								<div class="netto-price-column__lowest-price netto-previous-js" data-nettoprevious-price="{{ supplyProduct.SubtotalPreviousPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-nettolowest-price="{{ supplyProduct.SubtotalMinPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% endif -%}>{{ supplyProduct.SubtotalPreviousPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.SuggestedRetailPrice}}</div>
																							{% else -%}
																								<div class="netto-price-column__previous-price" data-nettoprevious-price="{{ supplyProduct.SubtotalPreviousPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-nettolowest-price="{{ supplyProduct.SubtotalMinPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% endif -%}>
																									<span class="netto-previous-js">{{ supplyProduct.SubtotalPreviousPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}</span>
																								</div>
																							{% endif -%}
																						{% elseif supplyProduct.SubtotalRegularPrice != null and supplyProduct.SubtotalRegularPrice > supplyProduct.SubtotalPrice and settings.lowestProductPrice == 'no' -%}
																							<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																							<div class="netto-price-column__previous-price" data-nettoprevious-price="{{ supplyProduct.SubtotalRegularPrice | DividedBy: supplyProduct.BasicUnitRatio }}">
																								<span class="netto-previous-js">{{ supplyProduct.SubtotalRegularPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} </span>
																							</div>
																						{% endif -%}
																					</span>
																					{% if supplyProduct.DepositValue > 0 -%}
																						<span class="netto-price-column__deposit-price">
																							<span>+ {{translations.Com_Deposit}}: </span>
																							<span class="deposit-js" data-deposit-price="{{ supplyProduct.DepositValue | Times: supplyProduct.BasicUnitRatio }}">
																								{{ supplyProduct.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} / {{ supplyProduct.BasicUnit }}
																							</span>
																						</span>
																					{% endif -%}
																					{% if settings.showUnitRateOnProductDetailsPage == 'yes' and supplyProduct.Units[1] %}
																						{% for unit in supplyProduct.Units -%}
																							{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																								{% if unit.Id != supplyUnitId -%}
																									<div class="netto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																										{{ supplyProduct.SubtotalPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{supplyUnitName}}
																									</div>
																								{% endif -%}
																							{% else -%}
																								{% if unit.Name != supplyProduct.BasicUnit -%}
																									<div class="netto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																										{{ supplyProduct.SubtotalPrice | DividedBy: supplyProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{supplyProduct.BasicUnit}}
																									</div>
																								{% endif -%}
																							{% endif -%}
																						{% endfor -%}
																					{% endif -%}
																					{% if supplyProduct.SubtotalPreviousPrice != null and supplyProduct.SubtotalPreviousPrice > supplyProduct.SubtotalPrice and settings.lowestProductPrice == 'yes' -%}
																						<div class="netto-price-column__lowest-price netto-lowest-js">{{ supplyProduct.SubtotalMinPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.Price_Omnibus}}</div>
																					{% endif -%}
																				{% elseif customer.HidePrices -%}
																					{% if settings.signIn == "page" -%}
																						<a class="netto-price-column__sign-in-on-child" href="{{ page.BaseHref }}{{config.DefinedPages.Login.Url}}" rel="nofollow">{{ translations.SignIn }}</a>
																					{% else -%}
																						<a class="netto-price-column__sign-in-on-child show-login-popup-js" rel="nofollow">{{ translations.SignIn }}</a>
																					{% endif -%}
																					<div class="netto-price-column__tooltip">
																						<svg class="icon">
																							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{settings.iconStyle}}"></use>
																						</svg>
																						<div class="text">
																							<p>{{ translations.PricesAvalibleForSignedIn }}. {% if settings.signIn == "page" -%}<a href="{{page.BaseHref}}{{config.DefinedPages.Login.Url}}" rel="nofollow">{{ translations.SignIn }}</a>{% else -%}<a class="show-login-popup-js" rel="nofollow">{{ translations.SignIn }}</a>{% endif -%}, {{ translations.ToSeePrices | Downcase }}.</p>
																						</div>
																					</div>
																				{% else -%}
																				<a aria-label="ask-for-price" style="gap:8px;" class="pure-button" href="{{ urlHref }}">
																						{{ translations.AskForPrice }}
																						<svg width="20" height="20" class="primary-action-button__icon">
																							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{ settings.iconStyle }}"></use>
																						</svg>
																					</a>
																				{% endif -%}
																			</td>
																			<td class="brutto-price-column" data-brutto-price="{{ supplyProduct.TotalPrice | DividedBy: supplyProduct.BasicUnitRatio }}">
																				{% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}
																					{% if supplyProduct.TotalPrice != null -%}
																						<span class="brutto-price-column__price">
																							<span class="brutto-js">
																								{{ supplyProduct.TotalPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }}
																							</span>
																							<span class="price">{{ currencyExt }}</span>
																							{% if supplyProduct.TotalPreviousPrice != null and supplyProduct.TotalPreviousPrice > supplyProduct.TotalPrice -%}
																								<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																								{% if settings.previousPriceAsSuggestedRetailPrice == 'yes' -%}
																									<div class="brutto-price-column__lowest-price brutto-previous-js" data-bruttoprevious-price="{{ supplyProduct.TotalPreviousPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-bruttolowest-price="{{ supplyProduct.TotalMinPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% endif -%}>{{ supplyProduct.TotalPreviousPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.SuggestedRetailPrice}}</div>
																								{% else -%}
																									<div class="brutto-price-column__previous-price" data-bruttoprevious-price="{{ supplyProduct.TotalPreviousPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-bruttolowest-price="{{ supplyProduct.TotalMinPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% endif -%}>
																										<span class="brutto-previous-js">{{ supplyProduct.TotalPreviousPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}</span>
																									</div>
																								{% endif -%}
																							{% elseif supplyProduct.TotalRegularPrice != null and supplyProduct.TotalRegularPrice > supplyProduct.TotalPrice and settings.lowestProductPrice == 'no' -%}
																								<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																								<div class="brutto-price-column__previous-price" data-bruttoprevious-price="{{ supplyProduct.TotalRegularPrice | DividedBy: supplyProduct.BasicUnitRatio }}">
																									<span class="brutto-previous-js">{{ supplyProduct.TotalRegularPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}</span>
																								</div>
																							{% endif -%}
																						</span>
																						{% if supplyProduct.DepositValue > 0 -%}
																							<span class="brutto-price-column__deposit-price">
																								<span>+ {{translations.Com_Deposit}}: </span>
																								<span class="deposit-js" data-deposit-price="{{ supplyProduct.DepositValue | Times: supplyProduct.BasicUnitRatio }}">
																									{{ supplyProduct.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} / {{ supplyProduct.BasicUnit }}
																								</span>
																							</span>
																						{% endif -%}
																						{% if settings.showUnitRateOnProductDetailsPage == 'yes' and supplyProduct.Units[1] %}
																							{% for unit in supplyProduct.Units -%}
																								{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																									{% if unit.Id != supplyUnitId -%}
																										<div class="brutto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																											{{ supplyProduct.TotalPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{supplyUnitName}}
																										</div>
																									{% endif -%}
																								{% else -%}
																									{% if unit.Name != supplyProduct.BasicUnit -%}
																										<div class="brutto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																											{{ supplyProduct.TotalPrice | DividedBy: supplyProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{supplyProduct.BasicUnit}}
																										</div>
																									{% endif -%}
																								{% endif -%}
																							{% endfor -%}
																						{% endif -%}
																						{% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}
																							{% if supplyProduct.TotalPreviousPrice != null and supplyProduct.TotalPreviousPrice > supplyProduct.TotalPrice and settings.lowestProductPrice == 'yes' -%}
																								<div class="brutto-price-column__lowest-price brutto-lowest-js">{{ supplyProduct.TotalMinPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.Price_Omnibus}}</div>
																							{% endif -%}
																						{% endunless -%}
																					{% elseif customer.HidePrices -%}
																							{% if settings.signIn == "page" -%}
																								<a class="brutto-price-column__sign-in-on-child" href="{{ page.BaseHref }}{{config.DefinedPages.Login.Url}}" rel="nofollow">{{ translations.SignIn }}</a>
																							{% else -%}
																								<a class="brutto-price-column__sign-in-on-child show-login-popup-js" rel="nofollow">{{ translations.SignIn }}</a>
																							{% endif -%}
																							<div class="brutto-price-column__tooltip">
																								<svg class="icon">
																									<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{settings.iconStyle}}"></use>
																								</svg>
																								<div class="text">
																									<p>{{ translations.PricesAvalibleForSignedIn }}. {% if settings.signIn == "page" -%}<a href="{{page.BaseHref}}{{config.DefinedPages.Login.Url}}" rel="nofollow">{{ translations.SignIn }}</a>{% else -%}<a class="show-login-popup-js" rel="nofollow">{{ translations.SignIn }}</a>
																								{% endif -%}, {{ translations.ToSeePrices | Downcase }}.</p>
																								</div>
																							</div>
																					{% else -%}
																					<a aria-label="ask-for-price" style="gap:8px;" class="pure-button" href="{{ urlHref }}">
																							{{ translations.AskForPrice }}
																							<svg width="20" height="20" class="primary-action-button__icon">
																								<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{ settings.iconStyle }}"></use>
																							</svg>
																						</a>
																					{% endif -%}
																				{% endunless -%}
																			</td>
																		{% else -%}
																			{% if customer.Cart.SubtotalPrices -%}
																				<td class="netto-price-column" data-netto-price="{{ supplyProduct.Price | DividedBy: supplyProduct.BasicUnitRatio }}">
																					{% if supplyProduct.Price != null -%}
																						<span class="netto-price-column__price">
																							<span class="netto-js">
																								{{ supplyProduct.Price | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }}
																							</span>
																							<span class="price">{{ currencyExt }}</span>
																							{% if supplyProduct.PreviousPrice != null and supplyProduct.PreviousPrice > supplyProduct.Price -%}
																								<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																								{% if settings.previousPriceAsSuggestedRetailPrice == 'yes' %}
																									<div class="netto-price-column__lowest-price netto-previous-js" data-nettoprevious-price="{{ supplyProduct.PreviousPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-nettolowest-price="{{ supplyProduct.MinPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% endif -%}>{{ supplyProduct.PreviousPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.SuggestedRetailPrice}}</div>
																								{% else -%}
																									<div class="netto-price-column__previous-price" data-nettoprevious-price="{{ supplyProduct.PreviousPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-nettolowest-price="{{ supplyProduct.MinPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% endif -%}>
																										<span class="netto-previous-js">{{ supplyProduct.PreviousPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}</span>
																									</div>
																								{% endif -%}
																							{% endif -%}
																						</span>
																						{% if supplyProduct.DepositValue > 0 -%}
																							<span class="netto-price-column__deposit-price">
																								<span>+ {{translations.Com_Deposit}}: </span>
																								<span class="deposit-js" data-deposit-price="{{ supplyProduct.DepositValue | Times: supplyProduct.BasicUnitRatio }}">
																									{{ supplyProduct.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} / {{ supplyProduct.BasicUnit }}
																								</span>
																							</span>
																						{% endif -%}
																						{% if settings.showUnitRateOnProductDetailsPage == 'yes' and supplyProduct.Units[1] %}
																							{% for unit in supplyProduct.Units -%}
																								{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																									{% if unit.Id != supplyUnitId -%}
																										<div class="netto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																											{{ supplyProduct.Price | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{supplyUnitName}}
																										</div>
																									{% endif -%}
																								{% else -%}
																									{% if unit.Name != supplyProduct.BasicUnit -%}
																										<div class="netto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																											{{ supplyProduct.Price | DividedBy: supplyProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{supplyProduct.BasicUnit}}
																										</div>
																									{% endif -%}
																								{% endif -%}
																							{% endfor -%}
																						{% endif -%}
																						{% if supplyProduct.PreviousPrice != null and supplyProduct.PreviousPrice > supplyProduct.Price and settings.lowestProductPrice == 'yes' -%}
																							<div class="netto-price-column__lowest-price netto-lowest-js">{{ supplyProduct.MinPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.Price_Omnibus}}</div>
																						{% endif -%}
																					{% elseif customer.HidePrices -%}
																						{% if settings.signIn == "page" -%}
																							<a class="netto-price-column__sign-in-on-child" href="{{ page.BaseHref }}{{config.DefinedPages.Login.Url}}" rel="nofollow">{{ translations.SignIn }}</a>
																						{% else -%}
																							<a class="netto-price-column__sign-in-on-child show-login-popup-js" rel="nofollow">{{ translations.SignIn }}</a>
																						{% endif -%}
																						<div class="netto-price-column__tooltip">
																							<svg class="icon">
																								<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{settings.iconStyle}}"></use>
																							</svg>
																							<div class="text">
																								<p>{{ translations.PricesAvalibleForSignedIn }}. {% if settings.signIn == "page" -%}<a href="{{page.BaseHref}}{{config.DefinedPages.Login.Url}}" rel="nofollow">{{ translations.SignIn }}</a>{% else -%}<a class="show-login-popup-js" rel="nofollow">{{ translations.SignIn }}</a>{% endif -%}, {{ translations.ToSeePrices | Downcase }}.</p>
																							</div>
																						</div>
																					{% else -%}
																						<a aria-label="ask-for-price" style="gap:8px;" class="pure-button" href="{{ urlHref }}">
																							{{ translations.AskForPrice }}
																							<svg width="20" height="20" class="primary-action-button__icon">
																								<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{ settings.iconStyle }}"></use>
																							</svg>
																						</a>
																					{% endif -%}
																				</td>
																			{% else -%}
																				<td class="brutto-price-column" data-brutto-price="{{ supplyProduct.Price | DividedBy: supplyProduct.BasicUnitRatio }}">
																					{% if supplyProduct.Price != null -%}
																						<span class="brutto-price-column__price">
																							<span class="brutto-js">
																								{{ supplyProduct.Price | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }}
																							</span>
																							<span class="price">{{ currencyExt }}</span>
																							{% if supplyProduct.PreviousPrice != null and supplyProduct.PreviousPrice > supplyProduct.Price -%}
																								<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																								{% if settings.previousPriceAsSuggestedRetailPrice == 'yes' -%}
																									<div class="brutto-price-column__lowest-price brutto-previous-js" data-bruttoprevious-price="{{ supplyProduct.PreviousPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-bruttolowest-price="{{ supplyProduct.MinPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% endif -%}>{{ supplyProduct.PreviousPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} {{ currencyExt }} - {{translations.SuggestedRetailPrice}}</div>
																								{% else -%}
																									<div class="brutto-price-column__previous-price" data-bruttoprevious-price="{{ supplyProduct.PreviousPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-bruttolowest-price="{{ supplyProduct.MinPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% endif -%}>
																										<span class="brutto-previous-js">{{ supplyProduct.PreviousPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}</span>
																									</div>
																								{% endif -%}
																							{% endif -%}
																						</span>
																						{% if supplyProduct.DepositValue > 0 -%}
																							<span class="brutto-price-column__deposit-price">
																								<span>+ {{translations.Com_Deposit}}: </span>
																								<span class="deposit-js" data-deposit-price="{{ supplyProduct.DepositValue | Times: supplyProduct.BasicUnitRatio }}">
																									{{ supplyProduct.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} / {{ supplyProduct.BasicUnit }}
																								</span>
																							</span>
																						{% endif -%}
																						{% if settings.showUnitRateOnProductDetailsPage == 'yes' and supplyProduct.Units[1] %}
																							{% for unit in supplyProduct.Units -%}
																								{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																									{% if unit.Id != supplyUnitId -%}
																										<div class="brutto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																											{{ supplyProduct.Price | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{supplyUnitName}}
																										</div>
																									{% endif -%}
																								{% else -%}
																									{% if unit.Name != supplyProduct.BasicUnit -%}
																										<div class="brutto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																											{{ supplyProduct.Price | DividedBy: supplyProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{supplyProduct.BasicUnit}}
																										</div>
																									{% endif -%}
																								{% endif -%}
																							{% endfor -%}
																						{% endif -%}
																						{% if supplyProduct.PreviousPrice != null and supplyProduct.PreviousPrice > supplyProduct.Price and settings.lowestProductPrice == 'yes' -%}
																							<div class="brutto-price-column__lowest-price brutto-lowest-js">{{ supplyProduct.MinPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.Price_Omnibus}}</div>
																						{% endif -%}
																					{% elseif customer.HidePrices -%}
																						{% if settings.signIn == "page" -%}
																							<a class="brutto-price-column__sign-in-on-child" href="{{ page.BaseHref }}{{config.DefinedPages.Login.Url}}" rel="nofollow">{{ translations.SignIn }}</a>
																						{% else -%}
																							<a class="brutto-price-column__sign-in-on-child show-login-popup-js" rel="nofollow">{{ translations.SignIn }}</a>
																						{% endif -%}
																						<div class="brutto-price-column__tooltip">
																							<svg class="icon">
																								<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{settings.iconStyle}}"></use>
																							</svg>
																							<div class="text">
																								<p>{{ translations.PricesAvalibleForSignedIn }}. {% if settings.signIn == "page" -%}<a href="{{page.BaseHref}}{{config.DefinedPages.Login.Url}}" rel="nofollow">{{ translations.SignIn }}</a>{% else -%}<a class="show-login-popup-js" rel="nofollow">{{ translations.SignIn }}</a>{% endif -%}, {{ translations.ToSeePrices | Downcase }}.</p>
																							</div>
																						</div>
																					{% else -%}
																						<a aria-label="ask-for-price" style="gap:8px;" class="pure-button" data-container=".popup-js" href="{{ urlHref }}">
																							{{ translations.AskForPrice }}
																							<svg width="20" height="20" class="primary-action-button__icon">
																								<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{ settings.iconStyle }}"></use>
																							</svg>
																						</a>
																					{% endif -%}
																				</td>
																			{% endif -%}
																		{% endif -%}
																		{% if noSupplyProductOnControlledStock or supplyProduct.Availability.Status == 3 -%}
																			<td class="notify-about-availability-column" colspan="1">
																				{% if customer.HidePrices == false -%}
																					<a class="notify-about-availability-column__button" href="{{ urlHref }}?open=notifyMe">{{ translations.NotifyAboutAvailability }}</a>
																				{% endif -%}
																			</td>
																			{% if config.Stock.Enabled -%}
																				<td class="quantity-column ammount-stepper-js" data-quantity="{% if config.Products.DecimalUnits -%}0{{ config.DecimalSeparator }}00{% else -%}0{% endif -%}" {% if supplyStockLevel != null and supplyStockLevel.QuantityControl and showStock -%} data-stock-value="{{ supplyStockLevel.Value | Normalize }}" data-basic-unit="{{ supplyProduct.BasicUnitRatio }}" {% endif -%} data-supply-id="{{supplyProduct.Id}}"></td>
																			{% endif -%}
																		{% else -%}
																			{% if supplyStockLevel != null and showStock -%}
																				<td class="stock-column" {% if supplyStockLevel != null and supplyStockLevel.QuantityControl == false and showStock -%} data-stock-not-max-value="{{ supplyStockLevel.Value | Normalize }}" data-basic-unit="{{ supplyProduct.BasicUnitRatio }}" {% endif -%}>
																					<div class="stock-column-data">
																						{% if supplyStockLevel.ImageUrl != null -%}
																							{% if supplyStockLevel.Type == 1 or supplyStockLevel.Type == 2 -%}
																								<img alt="{{ supplyStockLevel.Text }}" {% if supplyStockLevel.Text != null -%} {% if supplyStockLevel.Type == 1 or supplyStockLevel.Type == 3 -%} title="{{ supplyStockLevel.Text }}" {% endif -%} {% endif -%} src="css/img/alo.gif" data-src="{{ supplyStockLevel.ImageUrl }}">
																							{% endif -%}
																						{% endif -%}
																						<div class="stock">
																							{% if supplyStockLevel.Type == 1 or supplyStockLevel.Type == 3 -%}{{ supplyStockLevel.Text }}{% elseif supplyStockLevel.Type == 4 -%}: <span class="max-js">{{ supplyStockLevel.Value | Normalize }}</span>{% endif %}
																						</div>
																					</div>
																				</td>
																			{% endif -%}
																			<td class="quantity-column ammount-stepper-js" data-quantity="{% if config.Products.DecimalUnits -%}0{{ config.DecimalSeparator }}00{% else -%}0{% endif -%}" {% if supplyStockLevel != null and supplyStockLevel.QuantityControl and showStock -%} data-stock-value="{{ supplyStockLevel.Value | Normalize }}" data-basic-unit="{{ supplyProduct.BasicUnitRatio }}" {% endif -%} data-supply-id="{{supplyProduct.Id}}">
																				{% if noSupplyProductOnControlledStock == false and supplyProduct.AskForPrice == false and supplyProduct.Availability.Status != 3 -%}
																					{% if product.Clip -%}
																						{% include 'partials/product/amount-stepper.html' with supplyProduct -%}
																					{% elseif product.Batch -%}
																						{% include 'partials/product/amount-stepper.html' with supplyStockLevel -%}
																					{% endif -%}
																				{% endif -%}
																			</td>
																			{% assign unitRatioInfo = false -%}
																			{% if settings.showUnitRateOnProductDetailsPage == 'yes' and settings.showUnitRateOnProductDetailsPageUnit == 'basic' and supplyUnitName != supplyProduct.BasicUnit -%}
																				{% assign unitRatioInfo = true -%}
																			{% endif -%}
																		{% endif -%}
																		<td class="unit-column unit-ratio-js" data-unit="{{ unitId }}" data-unit-ratio-info="{{unitRatioInfo}}" data-basic-unit-ratio="{{supplyProduct.BasicUnitRatio}}">
																			{% if supplyProduct.Units[1] -%}
																				<div tabindex="0" class="unit-column__units select select-js child-select-js">
																					<select id="unit-select-{{ supplyProduct.Id }}-{{ forloop.index0 }}" class="memory-js" data-index="{{ forloop.index0}}" aria-label="{{ translations.Unit }}">
																						{% for unit in supplyProduct.Units -%}
																							{% if unit.Id == unitId -%}
																								{% assign defaultUnitName = unit.Name -%}
																							{% endif -%}
																							<option value="{{ unit.Id }}" {% if unit.Id == supplyUnitId -%} selected {% endif -%}>{{ unit.Name | H }}</option>
																						{% endfor -%}
																					</select>
																					<div class="select__input">
																						<span class="selected-js">
																							{{ defaultUnitName | H }}
																						</span>
																						<svg>
																							<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
																						</svg>
																					</div>
																					<ul class="select__options options-js units-in-table-js">
																						{% for unit in supplyProduct.Units -%}
																							<li data-ratio="{{ unit.Ratio }}" data-value="{{ unit.Id }}" {% if unit.Multiplicity > 0 -%} data-multiplicity="{{ unit.Multiplicity }}" {% endif -%}>{{ unit.Name | H }}</li>
																						{% endfor -%}
																					</ul>
																					<input id="unit-dimensions-{{ supplyProduct.Id }}-{{ forloop.index0 }}" class="dimensions-js" type="hidden"
																					{% for unit in supplyProduct.Units -%}
																						{% assign dimensionsByUnitIndex = unit.Dimensions  -%}
																						data-unit{{unit.Id}}="{{dimensionsByUnitIndex.Height}}|{{dimensionsByUnitIndex.Length}}|{{dimensionsByUnitIndex.Width}}"
																					{% endfor -%}>
																				</div>
																				<div class="unit-column__unit-ratio-info">
																					{% if settings.showUnitRateOnProductDetailsPage == 'yes' -%}
																						{% assign productUnitsSize = supplyProduct.Units | Size -%}
																						{% for unit in supplyProduct.Units -%}
																							{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																								{% if unit.Id != supplyUnitId -%}
																									<span class="unit-ratio-info-js {% if productUnitsSize > 1 -%} hidden-js {% endif -%}" data-id="{{unit.Id}}">{{ unit.Ratio | DividedBy: supplyUnitRatio | Round: 4 }} {{ supplyUnitName }}</span>
																								{% endif -%}
																							{% else -%}
																								{% if unit.Name != supplyProduct.BasicUnit -%}
																									<span class="unit-ratio-info-js {% if productUnitsSize > 1 -%} hidden-js {% endif -%}" data-id="{{unit.Id}}">{{unit.Ratio | Round: 4}} {{supplyProduct.BasicUnit}}</span>
																								{% endif -%}
																							{% endif -%}
																						{% endfor -%}
																					{% endif -%}
																				</div>
																			{% else -%}
																				{{ supplyUnitName }}
																			{% endif -%}
																			{% if supplyProduct.BasicUnitMinQuantity > 1 -%}
																				<div class="min-quantity-info">
																					<svg>
																						<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#exclamation-triangle-{{settings.iconStyle}}'></use>
																					</svg>
																					<span>
																						{{ translations.FillProperMinQuantity }} <strong>{{ supplyProduct.BasicUnitMinQuantity | Round }} {{ supplyProduct.BasicUnit }}</strong>
																					</span>
																				</div>
																			{% endif -%}
																		</td>
																		
																		{% if showCouponsPopup -%}
																			<td>
																				<div class="product-item__coupons-container product-container">
																					<input type="hidden" name="productId" value="{{ supplyProduct.Id }}" />
																					<input type="hidden" name="productCode" value="{{ supplyProduct.Code | H }}" />
																					<input type="hidden" name="productName" value="{{ supplyProduct.NameNoHtml | H }}" />
																					{% if supplyProduct.Image.Id > 0 and supplyProduct.Image.Link != null -%}
																						<input type="hidden" name="productImage" value="img/small/{{ supplyProduct.Image.Id }}/{{ supplyProduct.Image.Link }}" />
																					{% elsif supplyProduct.Image.ExternalUrl != null -%}
																						<input type="hidden" name="productImage" value="{{ supplyProduct.Image.ExternalUrl }}" />
																					{% else -%}
																						<input type="hidden" name="productImage" value="" />
																					{% endif -%}						
																					<button class="show-more-coupons-product-list show-more-coupons-product-list-js" style="position: relative;z-index: 2;" data-product-id="{{supplyProduct.Id}}" data-url="{{ page.BaseHref }}{{product.Url}}">{{ translations.ShowDiscounts }}</button>
																				</div>
																			</td>
																		{% endif -%}
																		
																		{% if supply.ValueId == key -%}
																			{% assign supplies = supply.Supplies -%}
																		{% endif -%}
																		<input name="supplyId" type="hidden" value="{{ supply.SupplyId }}" data-supply="{{ supply.SupplyId }}">
																		{% assign dataKeys = dataKeys | Split:',' -%}
																		{% for keyVal in dataKeys -%}
																			<input name="attributeId" type="hidden" value="{{ keyVal }}" data-key="{{ keyVal }}">
																		{% endfor -%}
																	</tr>
																	{% if noSupplyProductOnControlledStock == false and supplyProduct.Availability.Status != 3 -%}
																		{% if supplyProduct.AttributesEditable[0] or supplyProduct.AttributesPolyvalent[0] -%}
																		<tr class="attr-container-row {% if noSupplyProductOnControlledStock or supplyProduct.Availability.Status == 3 -%} unavailable {% endif -%} {% if supplyProduct.AskForPrice -%} ask-for-price-child-js {% endif -%}" data-url="{{ url }}?keys={{ dataKeys }}{% if unitId != null -%}&unit={{ unitId }}{% endif -%}" data-child-index="{{ forloop.index0 }}" data-supply-id="{{ supply.SupplyId }}" data-img="http:{{ page.BaseHref }}img/large/{{ supplyProduct.ImageId }}/.jpg" data-code="{{ supplyProduct.Code | H }}" data-weight="{{ supplyProduct.Weight }}" data-netweight="{{ supplyProduct.NetWeight}}">
																			<td colspan="100%">
																				<div class="last-level-attribute__more-attributes expandable-js">
																					<div class="attr-container">
																					{% if supplyProduct.AttributesEditable[0] -%}
																						{% for attrEditable in supplyProduct.AttributesEditable -%}
																							<div class="attribute-editable attribute-container-js">
																								<div class="form__input-wrapper">
																									{% case attrEditable.Format -%}
																										{% when 1 -%}
																											<label for="attrEditable-{{forloop.index}}" class="form__input-info input-info-js">{{ attrEditable.Name }}</label>
																											<input id="attrEditable-{{forloop.index}}" class="form__input-value input-value-js" type="text" name="attributeEditable" value="" maxlength="50" required >
																											<div class="form__input-value--clear-button">
																												<svg>
																													<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
																												</svg>
																											</div>	
																										{% when 2 -%}
																											<label for="attrEditable-{{forloop.index}}" class="form__input-info input-info-js">{{ attrEditable.Name }}</label>
																											<input id="attrEditable-{{forloop.index}}" class="form__input-value input-value-js" type="number" name="attributeEditable" value="" max="999999999999999" required >
																										{% when 3 -%}
																											<label for="attrEditable-{{forloop.index}}" class="form__input-info input-info-js on-label">{{ attrEditable.Name }}</label>
																											<div tabindex="0" class="select select-js">
																												<select id="attrEditable-{{forloop.index}}" class="memory-js" name="attributeEditable">
																													{% for val in attrEditable.Values %}
																														<option value="{{ val.ValueId }}">{{ val.Value }}</option>
																													{% endfor -%}
																												</select>
																												<div class="select__input">
																														<span class="selected-js" title="{{ attrEditable.Values[0].Value }}">
																															{{ attrEditable.Values[0].Value }}
																														</span>
																													<svg>
																														<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
																													</svg>
																												</div>
																												<ul class="select__options options-js">
																													{% for val in attrEditable.Values %}
																														<li data-value="{{ val.ValueId }}">{{ val.Value }}</li>
																													{% endfor -%}
																												</ul>
																											</div>
																										{% when 4 -%}
																											<label for="attrEditable-{{forloop.index}}" class="form__input-info input-info-js on-label">{{ attrEditable.Name }}</label>
																											<input id="attrEditable-{{forloop.index}}" class="form__input-value input-value-js" type="date" name="attributeEditable" value="" required >
																									{% endcase -%}
																									<div class="form__invalid-input validation-info-js validation-required-js hidden-js">
																										{{ translations.FillAttributeValue }}
																									</div>
																								</div>
																							</div>
																						{% endfor -%}
																					{% endif -%}
																					{% if supplyProduct.AttributesPolyvalent[0] -%}
																						{% for attrPolyvalent in supplyProduct.AttributesPolyvalent -%}
																							<div class="attribute-editable attribute-container-js">
																								<div class="form__input-wrapper">
																									<span class="form__input-info input-info-js on-label">{{ attrPolyvalent.Name }}</span>
																									<div tabindex="0" class="select select-js">
																										<select id="attribute-polyvalent-{{ forloop.index }}" class="memory-js" name="attributePolyvalent" aria-label="{{ attrPolyvalent.Name }}">
																											{% for val in attrPolyvalent.Values %}
																												<option value="{{ val.ValueId }}">{{ val.Value }}</option>
																											{% endfor -%}
																										</select>
																										<div class="select__input">
																												<span class="selected-js" title="{{ attrPolyvalent.Values[0].Value }}">
																													{{ attrPolyvalent.Values[0].Value }}
																												</span>
																											<svg>
																												<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
																											</svg>
																										</div>
																										<ul class="select__options options-js">
																											{% for val in attrPolyvalent.Values %}
																												<li data-name="attributePolyvalent" data-value="{{ val.ValueId }}">{{ val.Value }}</li>
																											{% endfor -%}
																										</ul>
																									</div>
																									<div class="form__invalid-input validation-info-js validation-required-js hidden-js">
																										{{ translations.FillAttributeValue }}
																									</div>
																								</div>
																							</div>
																						{% endfor -%}
																					{% endif -%}
																					</div>
																				</div>
																				</td>
																			</tr>
																		{% endif -%}
																	{% endif -%}
																{% endfor -%}
															</tbody>
														</table>
													</div>
												{% endif -%}
											{% endfor -%}
										{% endif -%}
									{% endif -%}
								{% endif -%}

								{% unless product.Clip or product.Batch -%}
									{% if graphicalVariants == true -%}
										{% if activeProduct.Availability.Status == 3 -%}
											{% assign notifyMe = true -%}
										{% else -%}
											{% assign notifyMe = false -%}
										{% endif -%}

										{% if activeProduct.AttributesPolyvalent[0] and activeProduct.AskForPrice == false and activeProduct.Archival == false and notifyMe == false -%}
											{% if settings.productIsInCart == 'productIsInCart-yes' -%}
												<input type="hidden" class="isInCartId" value="{{activeProduct.Id}}">
											{% endif -%}
											<div class="graphical-variants__container">
												<div class="attributes-container-js">
													{% assign levelsQuantity = activeProduct.AttributesPolyvalent | Size -%}			
													{% comment -%} <!-- First level with color or value (no thumbnail - same image) --> {% endcomment -%}
													{% assign firstLevelAttributePolyvalent = activeProduct.AttributesPolyvalent[0] -%}
													{% assign lvl = 1 -%}
													{% assign selectedAttributeId = attributeIds[0] -%}
													{% comment -%} <!-- Name and value of active variant --> {% endcomment -%}

													{% for value in firstLevelAttributePolyvalent.Values -%}
														{% if value.ValueId == selectedAttributeId -%}
															{% assign activeAttributeValue = value.Value -%}
															{% break -%}
														{% endif -%}
													{% endfor -%}
													<div class="attributes__container">
														{% assign attribute = firstLevelAttributePolyvalent -%}
														{% assign variantsSize = attribute.Values | Size -%}
														{% assign firstLevelName = attribute.Name -%}
														{% assign firstLevelValue = activeAttributeValue -%}
														
														<p class="name">{{firstLevelName}}: <span class="value graphical-variant-name-js">{{firstLevelValue}}</span></p>
														<div class="graphical-variants graphical-variants-js values">
															{% for value in attribute.Values -%}
																<div class="attributes-js">
																	<div class="graphical-variant graphical-variant-js {% if forloop.index > graphicalVariantsLimit and checked == false  -%} hidden-js {% endif -%} {% if value.ValueId == selectedAttributeId -%} active-js {% endif -%} {% if levelsQuantity == 1 %} last-level-attribute child-js with-attributes attr-poly-table-js attr-graphical-variants-js {% endif %}" {% if levelsQuantity == 1 -%} data-child-index="{{ forloop.index0 }}" data-weight="{{ activeProduct.Weight }}" data-netweight="{{ activeProduct.NetWeight }}" data-img="http:{{ page.BaseHref }}img/large/{{ activeProduct.ImageId }}/.jpg" data-code="{{ activeProduct.Code }}"{% endif -%}>
																		{% if settings.grapicalVariantsPresentation == 'Variants_Colors' -%}
																			{% assign anyColor = false -%}
																			{% for value in attribute.Values -%}
																				{% for color in colorVariants -%}
																					{% assign colorArr = color | Split: '||' -%}

																					{%comment %} <!-- Case-insensitive comparison --> {% endcomment -%}
																					{% assign valueDowncase = value.Value | Downcase -%}
																					{% assign colorDowncase = colorArr[0] | Downcase -%}
																					
																					{% if colorDowncase == valueDowncase -%}
																						{% assign anyColor = true -%}
																						{% break -%}
																					{% endif -%}
																				{% endfor -%}
																			{% endfor -%}

																			{% assign colorHex = '#FFFFFF' -%}
																			{% for color in colorVariants %}
																				{% assign colorArr = color | Split: '||' -%}

																				{%comment %} <!-- Case-insensitive comparison --> {% endcomment -%}
																				{% assign valueDowncase = value.Value | Downcase -%}
																				{% assign colorDowncase = colorArr[0] | Downcase -%}

																				{% if colorDowncase == valueDowncase -%}
																					{% assign colorHex = colorArr[1] -%}
																					{% break -%}
																				{% endif -%}
																			{% endfor -%}

																			{% comment %} <!-- Color representation --> {% endcomment %}
																			<label tabindex="0" class="chip {% if anyColor -%} chip--color {% else -%} chip--default {% endif -%}">
																				<input tabindex="-1" type="radio" name="attributeId" value="{{ value.ValueId }}" {% if value.ValueId == selectedAttributeId -%} checked {% endif -%} data-variant="{{ value.Value }}">
																				{% if anyColor -%}
																					<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
																						{% if colorHex == 'multicolor' %}
																							<foreignObject x="4" y="4" width="32" height="32">
																								<div xmlns="http://www.w3.org/1999/xhtml" class="multicolor"></div>
																							</foreignObject>
																						{% else %}
																							<circle cx="20" cy="20" r="16" fill="{{ colorHex }}" {% if colorHex == '#FFFFFF' %} stroke="black" stroke-width="0.25"{% endif %}/>
																						{% endif %}
																					</svg>
																				{% else -%}
																					{{value.Value}}
																				{% endif -%}
																			</label>
																		{% else -%}
																			{% comment %} <!-- Normal chip --> {% endcomment %}
																			<label tabindex="0" class="chip chip--default">
																				<input tabindex="-1" type="radio" name="attributeId" value="{{ value.ValueId }}" {% if value.ValueId == selectedAttributeId -%} checked {% endif -%} data-variant="{{ value.Value }}">
																				{{value.Value}}
																			</label>
																		{% endif -%}
																	</div>
																</div>
															{% endfor -%}
															
															{% assign showMoreCount = variantsSize | Minus: graphicalVariantsLimit -%}
															{% if showMoreCount > 0 -%}
																<label role="button" tabindex="0" class="open-variants-on-popup-js pure-button chip chip--showMore">
																	<input name="showMore" tabindex="-1" type="checkbox" data-count="{{ showMoreCount }}" {% if checked -%} checked {% endif -%}>
																	<span class="more">{{translations.More}} +{{ showMoreCount }}</span>
																	<span class="less">{{translations.Less}}</span>
																</label>
															{% endif -%}
														</div>
													</div>

													{% comment -%} <!-- Other levels --> {% endcomment -%}
													{% assign otherLevels = activeProduct.AttributesPolyvalent | Skip: 1 -%}
													{% assign levelsQuantity = activeProduct.AttributesPolyvalent | Size -%}

													{% for attribute in otherLevels -%}
														{% assign lvl = forloop.index | Plus: 1 -%}
														<div class="attributes__container attributes-js {% if lvl == levelsQuantity -%} attr-poly-table-js attr-graphical-variants-js {% endif -%}">
															{% comment -%}<!-- Level values-->{% endcomment -%}
															<p class="name">{{attribute.Name}}</p>
															<div class="values">
																{% for value in attribute.Values -%}
																	{% comment -%} <!-- Find the selected attribute id for the current level --> {% endcomment -%}
																	{% for attributeId in attributeIds -%}
																		{% if attributeId == value.ValueId -%}
																			{% assign activeAttributeId = attributeId -%}
																			{% break -%}
																		{% endif -%}
																	{% endfor -%}									

																	<button class="value {% if value.ValueId == activeAttributeId -%} active-js {% endif -%} {% if lvl == levelsQuantity -%} last-level-attribute child-js with-attributes{% endif -%}" {% if lvl == levelsQuantity -%} data-child-index="{{ forloop.index0 }}" data-weight="{{ activeProduct.Weight }}" data-netweight="{{ activeProduct.NetWeight }}" data-img="http:{{ page.BaseHref }}img/large/{{ activeProduct.ImageId }}/.jpg" data-code="{{ activeProduct.Code }}"{% endif -%} data-many-attributes-id="{{ value.ValueId }}">
																		{{ value.Value }}
																		<input name="attributeId" type="hidden" value="{{value.ValueId}}">
																	</button>
																{% endfor -%}
															</div>
														</div>
													{% endfor -%}
												</div>

												{% comment -%} <!-- Attributes editable --> {% endcomment -%}
												{% if activeProduct.AttributesEditable[0] -%}
													<div class="last-level-attribute attributes-container-js">
														<div class="last-level-attribute__more-attributes">
															{% for attrEditable in activeProduct.AttributesEditable -%}
																<div class="attribute-editable attribute-container-js">
																	<input name="attributeId" type="hidden" value="{{ attrEditable.Id }}">
																	<div class="form__input-wrapper">
																		{% case attrEditable.Format -%}
																			{% when 1 -%}
																				<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js">{{ attrEditable.Name }}</label>
																				<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="text" name="attributeEditable" value="" maxlength="50" >
																				<div class="form__input-value--clear-button">
																					<svg>
																						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
																					</svg>
																				</div>	
																			{% when 2 -%}
																				<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js">{{ attrEditable.Name }}</label>
																				<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="number" name="attributeEditable" value="" max="999999999999999" >
																			{% when 3 -%}
																				<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js on-label">{{ attrEditable.Name }}</label>
																				<div tabindex="0" class="select select-js">
																					<select id="attribute-edit-{{forloop.index}}" class="memory-js" name="attributeEditable">
																						{% for val in attrEditable.Values %}
																							<option value="{{ val.ValueId }}">{{ val.Value }}</option>
																						{% endfor -%}
																					</select>
																					<div class="select__input">
																						<span class="selected-js" title="{{ attrEditable.Values[0].Value }}">
																							{{ attrEditable.Values[0].Value }}
																						</span>
																						<svg>
																							<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
																						</svg>
																					</div>
																					<ul class="select__options options-js">
																						{% for val in attrEditable.Values %}
																							<li tabindex="-1" data-value="{{ val.ValueId }}">{{ val.Value }}</li>
																						{% endfor -%}
																					</ul>
																				</div>
																			{% when 4 -%}
																				<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js on-label">{{ attrEditable.Name }}</label>
																				<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="date" name="attributeEditable" value="" >
																		{% endcase -%}
																		<div class="form__invalid-input validation-info-js validation-required-js hidden-js">
																			{{ translations.FillAttributeValue }}
																		</div>
																	</div>
																</div>
															{% endfor -%}
														</div>
													</div>
												{% endif -%}

												{% comment -%} <!-- Quantity and Unit --> {% endcomment -%}
												<div class="graphical-variants__quantity-unit">
													<div class="graphical-variants__quantity quantity-column ammount-stepper-js" data-quantity="{% if config.Products.DecimalUnits -%}0{{ config.DecimalSeparator }}00{% else -%}0{% endif -%}" {% if activeProduct.StockLevel != null and activeProduct.StockLevel.QuantityControl and showStock -%} data-stock-value="{{ activeProduct.StockLevel.Value | Normalize }}" data-basic-unit="{{ activeProduct.BasicUnitRatio }}" {% endif -%}>
														{% include 'partials/product/amount-stepper.html' with activeProduct -%}
													</div>

													{% assign unitRatioInfo = false -%}
													{% if activeProduct.Units[1] and settings.showUnitRateOnProductDetailsPage == 'yes' and settings.showUnitRateOnProductDetailsPageUnit == 'basic' and unitName != activeProduct.BasicUnit -%}
														{% assign unitRatioInfo = true -%}
													{% endif -%}

													<div class="graphical-variants__unit unit-column unit-ratio-js" data-unit="{{ unitId }}" data-unit-ratio-info="{{unitRatioInfo}}" data-basic-unit-ratio="{{product.BasicUnitRatio}}">
														{% if activeProduct.Units[1] -%}
															<div tabindex="0" class="unit-column__units select select-js child-select-js">
																<select id="unit-select-{{ activeProduct.Id }}" class="memory-js" data-index="0" aria-label="{{ translations.Unit }}">
																	{% for unit in activeProduct.Units -%}
																		{% if unit.Id == unitId -%}
																			{% assign defaultUnitName = unit.Name -%}
																		{% endif -%}
																		<option value="{{ unit.Id }}" {% if unit.Id == unitId -%} selected {% endif -%}>{{ unit.Name | H }}</option>
																	{% endfor -%}
																</select>
																<div class="select__input">
																	<span class="selected-js">
																		{{ defaultUnitName | H }}
																	</span>
																	<svg>
																		<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
																	</svg>
																</div>

																<ul class="select__options options-js units-in-table-js">
																	{% for unit in product.Units -%}
																		<li tabindex="-1" data-ratio="{{ unit.Ratio }}" data-value="{{ unit.Id }}" {% if unit.Multiplicity > 0 -%} data-multiplicity="{{ unit.Multiplicity }}" {% endif -%}>{{ unit.Name | H }}</li>
																	{% endfor -%}
																</ul>
															</div>
															
															<div class="unit-column__unit-ratio-info">
																{% if settings.showUnitRateOnProductDetailsPage == 'yes' -%}
																	{% assign productUnitsSize = product.Units | Size -%}
																	{% for unit in product.Units -%}
																		{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																			{% if unit.Id != unitId -%}
																				<span class="unit-ratio-info-js {% if productUnitsSize > 1 -%} hidden-js {% endif -%}" data-id="{{unit.Id}}">{{ unit.Ratio | DividedBy: unitRatio | Round: 4 }} {{ unitName }}</span>
																			{% endif -%}
																		{% else -%}
																			{% if unit.Name != activeProduct.BasicUnit -%}
																				<span class="unit-ratio-info-js {% if productUnitsSize > 1 -%} hidden-js {% endif -%}" data-id="{{unit.Id}}">{{ unit.Ratio | Round: 4 }} {{ product.BasicUnit }}</span>
																			{% endif -%}
																		{% endif -%}
																	{% endfor -%}
																{% endif -%}
															</div>
														{% else -%}
															{{ activeProduct.SaleUnit }}
														{% endif -%}
														{% if activeProduct.BasicUnitMinQuantity > 1 -%}
															<div class="min-quantity-info">
																<svg>
																	<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#exclamation-triangle-{{settings.iconStyle}}'></use>
																</svg>
																<span>
																	{{ translations.FillProperMinQuantity }} <strong>{{ activeProduct.BasicUnitMinQuantity | Round }} {{ activeProduct.BasicUnit }}</strong>
																</span>
															</div>
														{% endif -%}
													</div>
												</div>
											</div>
										{% elseif activeProduct.AttributesEditable[0] and product.AskForPrice == false and product.Archival == false -%}
											{% comment -%} <!-- Quantity and Unit --> {% endcomment -%}
											<div class="graphical-variants__quantity-unit">
												<div class="graphical-variants__quantity quantity-column ammount-stepper-js" data-quantity="{% if config.Products.DecimalUnits -%}0{{ config.DecimalSeparator }}00{% else -%}0{% endif -%}" {% if activeProduct.StockLevel != null and activeProduct.StockLevel.QuantityControl and showStock -%} data-stock-value="{{ activeProduct.StockLevel.Value | Normalize }}" data-basic-unit="{{ activeProduct.BasicUnitRatio }}" {% endif -%}>
													{% include 'partials/product/amount-stepper.html' with activeProduct -%}
												</div>

												{% assign unitRatioInfo = false -%}
												{% if activeProduct.Units[1] and settings.showUnitRateOnProductDetailsPage == 'yes' and settings.showUnitRateOnProductDetailsPageUnit == 'basic' and unitName != activeProduct.BasicUnit -%}
													{% assign unitRatioInfo = true -%}
												{% endif -%}

												<div class="graphical-variants__unit unit-column unit-ratio-js" data-unit="{{ unitId }}" data-unit-ratio-info="{{unitRatioInfo}}" data-basic-unit-ratio="{{product.BasicUnitRatio}}">
													{% if activeProduct.Units[1] -%}
														<div tabindex="0" class="unit-column__units select select-js child-select-js">
															<select id="unit-select-{{ activeProduct.Id }}" class="memory-js" data-index="0" aria-label="{{ translations.Unit }}">
																{% for unit in activeProduct.Units -%}
																	{% if unit.Id == unitId -%}
																		{% assign defaultUnitName = unit.Name -%}
																	{% endif -%}
																	<option value="{{ unit.Id }}" {% if unit.Id == unitId -%} selected {% endif -%}>{{ unit.Name | H }}</option>
																{% endfor -%}
															</select>
															<div class="select__input">
																<span class="selected-js">
																	{{ defaultUnitName | H }}
																</span>
																<svg>
																	<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
																</svg>
															</div>

															<ul class="select__options options-js units-in-table-js">
																{% for unit in product.Units -%}
																	<li tabindex="-1" data-ratio="{{ unit.Ratio }}" data-value="{{ unit.Id }}" {% if unit.Multiplicity > 0 -%} data-multiplicity="{{ unit.Multiplicity }}" {% endif -%}>{{ unit.Name | H }}</li>
																{% endfor -%}
															</ul>
														</div>
														
														<div class="unit-column__unit-ratio-info">
															{% if settings.showUnitRateOnProductDetailsPage == 'yes' -%}
																{% assign productUnitsSize = product.Units | Size -%}
																{% for unit in product.Units -%}
																	{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																		{% if unit.Id != unitId -%}
																			<span class="unit-ratio-info-js {% if productUnitsSize > 1 -%} hidden-js {% endif -%}" data-id="{{unit.Id}}">{{ unit.Ratio | DividedBy: unitRatio | Round: 4 }} {{ unitName }}</span>
																		{% endif -%}
																	{% else -%}
																		{% if unit.Name != activeProduct.BasicUnit -%}
																			<span class="unit-ratio-info-js {% if productUnitsSize > 1 -%} hidden-js {% endif -%}" data-id="{{unit.Id}}">{{ unit.Ratio | Round: 4 }} {{ product.BasicUnit }}</span>
																		{% endif -%}
																	{% endif -%}
																{% endfor -%}
															{% endif -%}
														</div>
													{% else -%}
														{{ activeProduct.SaleUnit }}
													{% endif -%}
													{% if activeProduct.BasicUnitMinQuantity > 1 -%}
														<div class="min-quantity-info">
															<svg>
																<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#exclamation-triangle-{{settings.iconStyle}}'></use>
															</svg>
															<span>
																{{ translations.FillProperMinQuantity }} <strong>{{ activeProduct.BasicUnitMinQuantity | Round }} {{ activeProduct.BasicUnit }}</strong>
															</span>
														</div>
													{% endif -%}
												</div>
											</div>
										
											<p class="customize">{{ translations.Customize }}</p>
												<div class="test" data-child-index="0" data-weight="{{ activeProduct.Weight }}" data-netweight="{{ activeProduct.NetWeight }}" data-img="http:{{ page.BaseHref }}img/large/{{ activeProduct.ImageId }}/.jpg" data-code="{{ activeProduct.Code }}">
													{% for attribute in activeProduct.AttributesEditable -%}
														<div class="form__input-wrapper">
															<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js">{{ attribute.Name }} <span class="required">*</span></label>
															{% case attribute.Format -%}
																{% when 1 -%}
																	<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="text" name="attributeEditable" value="" maxlength="50" required >
																	<div class="form__input-value--clear-button">
																		<svg>
																			<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
																		</svg>
																	</div>											
																{% when 2 -%}
																	<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="number" name="attributeEditable" value="" max="999999999999999" required >
																{% when 3 -%}
																	<div tabindex="0" class="select select-js">
																		<select id="attribute-edit-{{forloop.index}}" class="memory-js" name="attributeEditable" data-id="{{attribute.Id}}" aria-label="{{ attribute.Name }}">
																			{% for val in attribute.Values %}
																				<option {% if val.ValueId == attribute.Values[0].ValueId -%} selected {% endif -%} value="{{ val.ValueId }}">{{ val.Value }}</option>
																			{% endfor -%}
																		</select>
																		<div class="select__input">
																			<span class="selected-js" title="{{ attrEditable.Values[0].Value }}">
																				{{ attrEditable.Values[0].Value }}
																			</span>
																			<svg width="16" height="16">
																				<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
																			</svg>
																		</div>
																		<ul class="select__options options-js">
																			{% for val in attribute.Values %}
																				<li tabindex="-1" data-value="{{ val.ValueId }}">{{ val.Value }}</li>
																			{% endfor -%}
																		</ul>
																	</div>
																{% when 4 -%}
																	<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="date" name="attributeEditable" value="" required >
															{% endcase -%}
															<div class="form__invalid-input validation-info-js validation-required-js hidden-js">
																{{ translations.FillAttributeValue }}
															</div>
														</div>
													</div>
												{% endfor -%}
										{% endif -%}
									{% else -%}
										{% if activeProduct.AttributesPolyvalent[0] and product.AskForPrice == false and product.Archival == false -%}
											{% if settings.productIsInCart == 'productIsInCart-yes' -%}
												<input type="hidden" class="isInCartId" value="{{activeProduct.Id}}">
											{% endif -%}
											{% for attribute in activeProduct.AttributesPolyvalent -%}
												<div class="attributes-js">
													{% assign lvl = forloop.index -%}
													{% assign levelsQuantity = activeProduct.AttributesPolyvalent | Size -%}
													{% if lvl != levelsQuantity -%}
														<div class="attributes__not-last-level-attribute">
															<input name="attributeId" type="hidden" value="{{ attribute.Values[0].ValueId }}">
															<div class="name">{{ attribute.Name }}</div>
															<div class="values">
																{% for value in attribute.Values -%}
																	<button aria-label="attribute-button" class="value {% if value.ValueId == attribute.Values[0].ValueId -%} active-js {% endif -%}" data-many-attributes-id="{{ value.ValueId }}">
																		{{ value.Value }}
																	</button>
																{% endfor -%}
															</div>
														</div>
													{% else -%}
														<div class="attributes__table-container attr-poly-table-js">
															<table>
																<thead>
																	<tr>
																		<th class="name-column attribute-name-js">{{ attribute.Name }}</th>
																		{% if config.ENTERPRISE -%}
																			<th class="netto-price-column">{{ translations.SubtotalPrice }}</th>
																			<th class="brutto-price-column">{% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}{{ translations.TotalPrice }}{% endunless -%}</th>
																		{% else -%}
																			{% if customer.Cart.SubtotalPrices -%}
																				<th class="netto-price-column">{{ translations.SubtotalPrice }}</th>
																			{% else -%}
																				<th class="brutto-price-column">{{ translations.TotalPrice }}</th>
																			{% endif -%}
																		{% endif -%}
																		{% if product.StockLevel != null and showStock -%}
																			<th class="stock-column">{{ translations.Stock }}</th>
																		{% endif -%}
																		<th class="quantity-column">{{ translations.Quantity }}</th>
																		<th class="unit-column">{{ translations.Unit }}</th>
																	</tr>
																</thead>
																<tbody>
																	{% if config.ENTERPRISE -%}
																		{% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}
																			{% if settings.showUnitRateOnProductDetailsPage == 'yes' and product.Units[1] -%}
																				{% assign unitRatioInfoExists = true -%}
																			{% endif -%}
																		{% endunless -%}
																		{% if activeProduct.TotalPreviousPrice != null and activeProduct.TotalPreviousPrice > activeProduct.TotalPrice -%}
																			{% assign previousPriceExists = true -%}
																		{% elseif activeProduct.TotalRegularPrice != null and activeProduct.TotalRegularPrice > activeProduct.TotalPrice -%}
																			{% assign previousPriceExists = true -%}
																		{% endif -%}
																	{% else -%}
																		{% if customer.Cart.SubtotalPrices -%}
																			{% if settings.showUnitRateOnProductDetailsPage == 'yes' and product.Units[1] -%}
																				{% assign unitRatioInfoExists = true -%}
																			{% endif -%}
																			{% if activeProduct.PreviousPrice != null and activeProduct.PreviousPrice > activeProduct.Price -%}
																				{% assign previousPriceExists = true -%}
																			{% endif -%}
																		{% else -%}
																				{% if settings.showUnitRateOnProductDetailsPage == 'yes' and product.Units[1] -%}
																					{% assign unitRatioInfoExists = true -%}
																				{% endif -%}
																				{% if activeProduct.PreviousPrice != null and activeProduct.PreviousPrice > activeProduct.Price -%}
																					{% assign previousPriceExists = true -%}
																				{% endif -%}
																		{% endif -%}
																	{% endif -%}
																	{% for value in attribute.Values -%}
																		<tr class="last-level-attribute child-js with-attributes" data-child-index="{{ forloop.index0 }}" data-weight="{{ product.Weight }}" data-netweight="{{ product.NetWeight}}">
																			<td class="name-column">{{ value.Value }}</td>
																			{% assign activeProductUnitsSize = activeProduct.Units | Size -%}
																			{% if settings.thresholds == 'yes' and activeProduct.HasThresholds and activeProduct.Price != null and activeProductUnitsSize == 1 -%}
																				<td class="thresholds-column" {% if config.ENTERPRISE -%} colspan="2" {% endif -%}>
																					{% assign whatPrice = translations.Brutto | Downcase -%}
																					{% if customer.Cart.SubtotalPrices -%}
																						{% assign whatPrice = translations.Netto | Downcase -%}
																					{% endif -%}
																					{% assign firstThreshold = activeProduct.Thresholds | First -%}
																					{% assign lastThreshold = activeProduct.Thresholds | Last -%}
																					<div class="thresholds-column__label">{{ translations.Price }} {{ whatPrice }}</div>
																					<div class="thresholds-column__range">
																						{{ translations.RangeFrom | Downcase }} <strong>{{ lastThreshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}</strong> {{ translations.RangeTo | Downcase }} {{ firstThreshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}
																					</div>
																					{% assign thresholdsSize = activeProduct.Thresholds | Size -%}
																					{% if thresholdsSize >= 2 -%}
																						<button class="thresholds-column__open-thresholds-popup pure-button open-next-element-js stop-propagation-js">
																						<span>{{ translations.SeePriceDetails }}</span>
																						</button>
																						<div class="popup-background hidden-js hide-js container-to-hide-js">
																							<div class="popup thresholds-popup">
																								<div class="popup__header">
																									<div class="title">{{ translations.PriceDetails }}</div>
																									<svg class="hide-container-js">
																										<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
																									</svg>
																								</div>
																								<div class="popup__content">
																									<div class="name">{{ activeProduct.Name }}</div>
																									<div class="thresholds">
																										<div class="thresholds__row">
																											<span>{{ translations.Quantity }} [{{ {{ product.SaleUnit }} }}]:</span>
																											<span>{{ translations.Price }} {{ whatPrice }}:</span>
																										</div>
																										{% for threshold in activeProduct.Thresholds -%}
																											<div class="thresholds__row">
																												<div>{{ threshold.Threshold | Normalize }}+</div>
																												<div>{{ threshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}</div>
																											</div>
																										{% endfor %}
																									</div>
																								</div>
																							</div>
																						</div>
																					{% endif -%}
																				</td>
																			{% elseif config.ENTERPRISE -%}
																				<td class="netto-price-column" data-netto-price="{{ activeProduct.SubtotalPrice | DividedBy: product.BasicUnitRatio }}">
																					<span class="netto-price-column__price">
																						<span class="netto-js">
																							{{ activeProduct.SubtotalPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }}
																						</span>
																						<span class="price">{{ currencyExt }}</span>
																						{% if activeProduct.SubtotalPreviousPrice != null and activeProduct.SubtotalPreviousPrice > activeProduct.SubtotalPrice -%}
																							<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																							{% if settings.previousPriceAsSuggestedRetailPrice == 'yes' %}
																								<div class="netto-price-column__lowest-price netto-previous-js" data-nettoprevious-price="{{ activeProduct.SubtotalPreviousPrice | DividedBy: product.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-nettolowest-price="{{ activeProduct.SubtotalMinPrice | DividedBy: product.BasicUnitRatio }}" {% endif -%}>{{ activeProduct.SubtotalPreviousPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.SuggestedRetailPrice}}</div>
																							{% else -%}
																								<div class="netto-price-column__previous-price" data-nettoprevious-price="{{ activeProduct.SubtotalPreviousPrice | DividedBy: product.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-nettolowest-price="{{ activeProduct.SubtotalMinPrice | DividedBy: product.BasicUnitRatio }}" {% endif -%}>
																									<span class="netto-previous-js">{{ activeProduct.SubtotalPreviousPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}</span>
																								</div>
																							{% endif -%}
																						{% elseif activeProduct.SubtotalRegularPrice != null and activeProduct.SubtotalRegularPrice > activeProduct.SubtotalPrice and settings.lowestProductPrice == 'no' -%}
																							<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																							<div class="netto-price-column__previous-price" data-nettoprevious-price="{{ activeProduct.SubtotalRegularPrice | DividedBy: product.BasicUnitRatio }}">
																								<span class="netto-previous-js">{{ activeProduct.SubtotalRegularPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} </span>
																							</div>
																						{% endif -%}
																					</span>
																					{% if activeProduct.DepositValue > 0 -%}
																						<span class="netto-price-column__deposit-price">
																							<span>+ {{translations.Com_Deposit}}: </span>
																							<span class="deposit-js" data-deposit-price="{{ activeProduct.DepositValue | DividedBy: product.BasicUnitRatio }}">
																								{{ activeProduct.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} / {{ activeProduct.BasicUnit }}
																							</span>
																						</span>
																					{% endif -%}
																					{% if settings.showUnitRateOnProductDetailsPage == 'yes' and product.Units[1] -%}
																						{% for unit in product.Units -%}
																							{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																								{% if unit.Id != unitId -%}
																									<div class="netto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																										{{ activeProduct.SubtotalPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{unitName}}
																									</div>
																								{% endif -%}
																							{% else -%}
																								{% if unit.Name != product.BasicUnit -%}
																									<div class="netto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																										{{ activeProduct.SubtotalPrice | DividedBy: product.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{product.BasicUnit}}
																									</div>
																								{% endif -%}
																							{% endif -%}
																						{% endfor -%}
																					{% endif -%}
																					{% if activeProduct.SubtotalPreviousPrice != null and activeProduct.SubtotalPreviousPrice > activeProduct.SubtotalPrice and settings.lowestProductPrice == 'yes' -%}
																						<div class="netto-price-column__lowest-price netto-lowest-js">{{ activeProduct.SubtotalMinPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.Price_Omnibus}}</div>
																					{% endif -%}
																				</td>
																				<td class="brutto-price-column" data-brutto-price="{{ activeProduct.TotalPrice | DividedBy: product.BasicUnitRatio }}">
																					{% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}
																						<span class="brutto-price-column__price">
																							<span class="brutto-js">
																								{{ activeProduct.TotalPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }}
																							</span>
																							<span class="price">{{ currencyExt }}</span>
																							{% if activeProduct.TotalPreviousPrice != null and activeProduct.TotalPreviousPrice > activeProduct.TotalPrice -%}
																								<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																								{% if settings.previousPriceAsSuggestedRetailPrice == 'yes' -%}
																									<div class="brutto-price-column__lowest-price brutto-previous-js" data-bruttoprevious-price="{{ activeProduct.TotalPreviousPrice | DividedBy: product.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-bruttolowest-price="{{ activeProduct.TotalMinPrice | DividedBy: product.BasicUnitRatio }}" {% endif -%}>{{ activeProduct.TotalPreviousPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.SuggestedRetailPrice}}</div>
																								{% else -%}
																									<div class="brutto-price-column__previous-price" data-bruttoprevious-price="{{ activeProduct.TotalPreviousPrice | DividedBy: product.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-bruttolowest-price="{{ activeProduct.TotalMinPrice | DividedBy: product.BasicUnitRatio }}" {% endif -%}>
																										<span class="brutto-previous-js">{{ activeProduct.TotalPreviousPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}</span>
																									</div>
																								{% endif -%}
																							{% elseif activeProduct.TotalRegularPrice != null and activeProduct.TotalRegularPrice > activeProduct.TotalPrice and settings.lowestProductPrice == 'no' -%}
																								<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																								<div class="brutto-price-column__previous-price" data-bruttoprevious-price="{{ activeProduct.TotalRegularPrice | DividedBy: product.BasicUnitRatio }}">
																									<span class="brutto-previous-js">{{ activeProduct.TotalRegularPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} </span>
																								</div>
																							{% endif -%}
																						</span>
																						{% if activeProduct.DepositValue > 0 -%}
																							<span class="brutto-price-column__deposit-price">
																								<span>+ {{translations.Com_Deposit}}: </span>
																								<span class="deposit-js" data-deposit-price="{{ activeProduct.DepositValue | DividedBy: product.BasicUnitRatio }}">
																									{{ activeProduct.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} / {{ activeProduct.BasicUnit }}
																								</span>
																							</span>
																						{% endif -%}
																						{% if settings.showUnitRateOnProductDetailsPage == 'yes' and product.Units[1] -%}
																							{% for unit in product.Units -%}
																								{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																									{% if unit.Id != unitId -%}
																										<div class="brutto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																											{{ activeProduct.TotalPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{unitName}}
																										</div>
																									{% endif -%}
																								{% else -%}
																									{% if unit.Name != product.BasicUnit -%}
																										<div class="brutto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																											{{ activeProduct.TotalPrice | DividedBy: product.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{product.BasicUnit}}
																										</div>
																									{% endif -%}
																								{% endif -%}
																							{% endfor -%}
																						{% endif -%}
																						{% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}
																							{% if activeProduct.TotalPreviousPrice != null and activeProduct.TotalPreviousPrice > activeProduct.TotalPrice and settings.lowestProductPrice == 'yes' -%}
																								<div class="brutto-price-column__lowest-price brutto-lowest-js">{{ activeProduct.TotalMinPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.Price_Omnibus}}</div>
																							{% endif -%}
																						{% endunless -%}
																					{% endunless -%}
																				</td>
																			{% else -%}
																				{% if customer.Cart.SubtotalPrices -%}
																					<td class="netto-price-column" data-netto-price="{{ activeProduct.Price | DividedBy: product.BasicUnitRatio }}">
																						<span class="netto-price-column__price">
																							<span class="netto-js">
																								{{ activeProduct.Price | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }}
																							</span>
																							<span class="price">{{ currencyExt }}</span>
																							{% if activeProduct.PreviousPrice != null and activeProduct.PreviousPrice > activeProduct.Price -%}
																								<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																								{% if settings.previousPriceAsSuggestedRetailPrice == 'yes' %}
																									<div class="netto-price-column__lowest-price netto-previous-js" data-nettoprevious-price="{{ activeProduct.PreviousPrice | DividedBy: product.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-nettolowest-price="{{ activeProduct.MinPrice | DividedBy: product.BasicUnitRatio }}" {% endif -%}>{{ activeProduct.PreviousPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.SuggestedRetailPrice}}</div>
																								{% else -%}
																									<div class="netto-price-column__previous-price" data-nettoprevious-price="{{ activeProduct.PreviousPrice | DividedBy: product.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-nettolowest-price="{{ activeProduct.MinPrice | DividedBy: product.BasicUnitRatio }}" {% endif -%}>
																										<span class="netto-previous-js">{{ activeProduct.PreviousPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}</span>
																									</div>
																								{% endif -%}
																							{% endif -%}
																						</span>
																						{% if activeProduct.DepositValue > 0 -%}
																							<span class="netto-price-column__deposit-price">
																								<span>+ {{translations.Com_Deposit}}: </span>
																								<span class="deposit-js" data-deposit-price="{{ activeProduct.DepositValue | DividedBy: product.BasicUnitRatio }}">
																									{{ activeProduct.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} / {{ activeProduct.BasicUnit }}
																								</span>
																							</span>
																						{% endif -%}
																						{% if settings.showUnitRateOnProductDetailsPage == 'yes' and product.Units[1] -%}
																							{% for unit in product.Units -%}
																								{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																									{% if unit.Id != unitId -%}
																										<div class="netto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																											{{ activeProduct.Price | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{unitName}}
																										</div>
																									{% endif -%}
																								{% else -%}
																									{% if unit.Name != product.BasicUnit -%}
																										<div class="netto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																											{{ activeProduct.Price | DividedBy: product.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{product.BasicUnit}}
																										</div>
																									{% endif -%}
																								{% endif -%}
																							{% endfor -%}
																						{% endif -%}
																						{% if activeProduct.PreviousPrice != null and activeProduct.PreviousPrice > activeProduct.Price and settings.lowestProductPrice == 'yes' -%}
																							<div class="netto-price-column__lowest-price netto-lowest-js">{{ activeProduct.MinPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.Price_Omnibus}}</div>
																						{% endif -%}
																					</td>
																				{% else -%}
																					<td class="brutto-price-column" data-brutto-price="{{ activeProduct.Price | DividedBy: product.BasicUnitRatio }}">
																						<span class="brutto-price-column__price">
																							<span class="brutto-js">
																								{{ activeProduct.Price | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }}
																							</span>
																							<span class="price">{{ currencyExt }}</span>
																							{% if activeProduct.PreviousPrice != null and activeProduct.PreviousPrice > activeProduct.Price -%}
																								<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																								{% if settings.previousPriceAsSuggestedRetailPrice == 'yes' -%}
																									<div class="brutto-price-column__lowest-price brutto-previous-js" data-bruttoprevious-price="{{ activeProduct.PreviousPrice | DividedBy: product.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-bruttolowest-price="{{ activeProduct.MinPrice | DividedBy: product.BasicUnitRatio }}" {% endif -%}>{{ activeProduct.PreviousPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.SuggestedRetailPrice}}</div>
																								{% else -%}
																									<div class="brutto-price-column__previous-price" data-bruttoprevious-price="{{ activeProduct.PreviousPrice | DividedBy: product.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-bruttolowest-price="{{ activeProduct.MinPrice | DividedBy: product.BasicUnitRatio }}" {% endif -%}>
																										<span class="brutto-previous-js">{{ activeProduct.PreviousPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}</span>
																									</div>
																								{% endif -%}
																							{% endif -%}
																						</span>
																						{% if activeProduct.DepositValue > 0 -%}
																							<span class="brutto-price-column__deposit-price">
																								<span>+ {{translations.Com_Deposit}}: </span>
																								<span class="deposit-js" data-deposit-price="{{ activeProduct.DepositValue | DividedBy: product.BasicUnitRatio }}">
																									{{ activeProduct.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} / {{ activeProduct.BasicUnit }}
																								</span>
																							</span>
																						{% endif -%}
																						{% if settings.showUnitRateOnProductDetailsPage == 'yes' and product.Units[1] -%}
																							{% for unit in product.Units -%}
																								{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																									{% if unit.Id != unitId -%}
																										<div class="brutto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																											{{ activeProduct.Price | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{unitName}}
																										</div>
																									{% endif -%}
																								{% else -%}
																									{% if unit.Name != product.BasicUnit -%}
																										<div class="brutto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																											{{ activeProduct.Price | DividedBy: product.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{product.BasicUnit}}
																										</div>
																									{% endif -%}
																								{% endif -%}
																							{% endfor -%}
																						{% endif -%}
																						{% if activeProduct.PreviousPrice != null and activeProduct.PreviousPrice > activeProduct.Price and settings.lowestProductPrice == 'yes' -%}
																							<div class="brutto-price-column__lowest-price brutto-lowest-js">{{ activeProduct.MinPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.Price_Omnibus}}</div>
																						{% endif -%}
																					</td>
																				{% endif -%}
																			{% endif -%}
																			{% if product.StockLevel != null and showStock -%}
																				<td class="stock-column" {% if activeProduct.StockLevel != null and activeProduct.StockLevel.QuantityControl == false and showStock -%} data-stock-not-max-value="{{ activeProduct.StockLevel.Value | Normalize }}" data-basic-unit="{{ product.BasicUnitRatio }}" {% endif -%}>
																					<div class="stock-column-data">
																					
																						{% if activeProduct.StockLevel.ImageUrl != null -%}
																							{% if activeProduct.StockLevel.Type == 1 or activeProduct.StockLevel.Type == 2 -%}
																								<img alt="{{ activeProduct.StockLevel.Text }}" {% if activeProduct.StockLevel.Text != null -%} {% if activeProduct.StockLevel.Type == 1 or activeProduct.StockLevel.Type == 3 -%} title="{{ activeProduct.StockLevel.Text }}" {% endif -%} {% endif -%} src="css/img/alo.gif" data-src="{{ activeProduct.StockLevel.ImageUrl }}">
																							{% endif -%}
																						{% elseif activeProduct.StockLevel.Text != null and activeProduct.StockLevel.Type == 3 -%}
																							{{ activeProduct.StockLevel.Text }}
																						{% else -%}
																							<span class="max-js">
																								{% if activeProduct.StockLevel.Value < 1000000 -%}
																									{% if config.Products.DecimalUnits -%}
																										{{ activeProduct.StockLevel.Value | Normalize }}
																									{% else -%}
																										{{ activeProduct.StockLevel.Value | Floor }}
																									{% endif -%}
																								{% else -%}
																									{{ translations.Limitless }}
																								{% endif -%}
																							</span>
																						{% endif -%}
																					</div>
																				</td>
																			{% endif -%}
																			{% assign attributeIndex = forloop.index0 -%}
																			<td class="quantity-column ammount-stepper-js" data-quantity="{% if config.Products.DecimalUnits -%}0{{ config.DecimalSeparator }}00{% else -%}0{% endif -%}" {% if activeProduct.StockLevel != null and activeProduct.StockLevel.QuantityControl and showStock -%} data-stock-value="{{ activeProduct.StockLevel.Value | Normalize }}" data-basic-unit="{{ product.BasicUnitRatio }}" {% endif -%}>
																				{% include 'partials/product/amount-stepper.html' with activeProduct -%}
																			</td>
																			{% assign unitRatioInfo = false -%}
																			{% if product.Units[1] and settings.showUnitRateOnProductDetailsPage == 'yes' and settings.showUnitRateOnProductDetailsPageUnit == 'basic' and unitName != product.BasicUnit -%}
																				{% assign unitRatioInfo = true -%}
																			{% endif -%}
																			<td class="unit-column unit-ratio-js" data-unit="{{ unitId }}" data-unit-ratio-info="{{unitRatioInfo}}" data-basic-unit-ratio="{{product.BasicUnitRatio}}">
																				{% if product.Units[1] -%}
																					<div tabindex="0" class="unit-column__units select select-js">
																						<select id="unit-select-{{ product.Id }}-{{ forloop.index0 }}" class="memory-js" data-index="{{ forloop.index0 }}" aria-label="{{ translations.Unit }}">
																							{% for unit in product.Units -%}
																								{% if unit.Id == unitId -%}
																									{% assign defaultUnitName = unit.Name -%}
																								{% endif -%}
																								<option value="{{ unit.Id }}" {% if unit.Id == unitId -%} selected {% endif -%}>{{ unit.Name | H }}</option>
																							{% endfor -%}
																						</select>
																						<div class="select__input">
																							<span class="selected-js">
																								{{ defaultUnitName | H }}
																							</span>
																							<svg>
																								<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
																							</svg>
																						</div>
																						<ul class="select__options options-js units-in-table-js">
																							{% for unit in product.Units -%}
																								<li data-ratio="{{ unit.Ratio }}" data-value="{{ unit.Id }}" {% if unit.Multiplicity > 0 -%} data-multiplicity="{{ unit.Multiplicity }}" {% endif -%}>{{ unit.Name | H }}</li>
																							{% endfor -%}
																						</ul>
																					</div>
																					<div class="unit-column__unit-ratio-info">
																						{% if settings.showUnitRateOnProductDetailsPage == 'yes' -%}
																							{% assign productUnitsSize = product.Units | Size -%}
																							{% for unit in product.Units -%}
																								{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																									{% if unit.Id != unitId -%}
																										<span class="unit-ratio-info-js {% if productUnitsSize > 1 -%} hidden-js {% endif -%}" data-id="{{unit.Id}}">{{ unit.Ratio | DividedBy: unitRatio | Round: 4 }} {{ unitName }}</span>
																									{% endif -%}
																								{% else -%}
																									{% if unit.Name != supplyProduct.BasicUnit -%}
																										<span class="unit-ratio-info-js {% if productUnitsSize > 1 -%} hidden-js {% endif -%}" data-id="{{unit.Id}}">{{ unit.Ratio | Round: 4 }} {{ product.BasicUnit }}</span>
																									{% endif -%}
																								{% endif -%}
																							{% endfor -%}
																						{% endif -%}
																					</div>
																				{% else -%}
																					{{ product.SaleUnit }}
																				{% endif -%}
																				{% if supplyProduct.BasicUnitMinQuantity > 1 -%}
																					<div class="min-quantity-info">
																						<svg>
																							<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#exclamation-triangle-{{settings.iconStyle}}'></use>
																						</svg>
																						<span>
																							{{ translations.FillProperMinQuantity }} <strong>{{ supplyProduct.BasicUnitMinQuantity | Round }} {{ supplyProduct.BasicUnit }}</strong>
																						</span>
																					</div>
																				{% endif -%}
																			</td>
																			{% if showCouponsPopup -%}
																				<td>
																					<div class="product-item__coupons-container product-container">
																						<input type="hidden" name="productId" value="{{ activeProduct.Id }}" />
																						<input type="hidden" name="productCode" value="{{ activeProduct.Code | H }}" />
																						<input type="hidden" name="productName" value="{{ activeProduct.NameNoHtml | H }}" />
																						{% if activeProduct.Image.Id > 0 and activeProduct.Image.Link != null -%}
																							<input type="hidden" name="productImage" value="img/small/{{ activeProduct.Image.Id }}/{{ activeProduct.Image.Link }}" />
																						{% elsif activeProduct.Image.ExternalUrl != null -%}
																							<input type="hidden" name="productImage" value="{{ activeProduct.Image.ExternalUrl }}" />
																						{% else -%}
																							<input type="hidden" name="productImage" value="" />
																						{% endif -%}	
																						<button class="show-more-coupons-product-list show-more-coupons-product-list-js" style="position: relative;z-index: 2;" data-product-id="{{activeProduct.Id}}" data-url="{{ page.BaseHref }}{{product.Url}}">{{ translations.ShowDiscounts }}</button>
																					</div>
																				</td>
																			{% endif -%}
																		</tr>
																		{% if activeProduct.AttributesEditable[0] -%}
																			<tr class="last-level-attribute" data-child-index="{{ forloop.index0 }}" data-weight="{{ product.Weight }}" data-netweight="{{ product.NetWeight}}">
																				<td colspan="100%" class="last-level-attribute__more-attributes">
																					<input name="attributePolyvalent" type="hidden" value="{{ value.ValueId }}">
																					{% for attrEditable in activeProduct.AttributesEditable -%}
																						<div class="attribute-editable attribute-container-js">
																							<div class="form__input-wrapper">
																								{% case attrEditable.Format -%}
																									{% when 1 -%}
																										<label for="attrEditable-{{forloop.index}}" class="form__input-info input-info-js">{{ attrEditable.Name }}</label>
																										<input id="attrEditable-{{forloop.index}}" class="form__input-value input-value-js" type="text" name="attributeEditable" value="" maxlength="50" required >
																										<div class="form__input-value--clear-button">
																											<svg>
																												<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
																											</svg>
																										</div>	
																									{% when 2 -%}
																										<label for="attrEditable-{{forloop.index}}" class="form__input-info input-info-js">{{ attrEditable.Name }}</label>
																										<input id="attrEditable-{{forloop.index}}" class="form__input-value input-value-js" type="number" name="attributeEditable" value="" max="999999999999999" required >
																									{% when 3 -%}
																										<label for="attrEditable-{{forloop.index}}" class="form__input-info input-info-js">{{ attrEditable.Name }}</label>
																										<div tabindex="0" class="select select-js">
																											<select id="attrEditable-{{forloop.index}}" class="memory-js" name="attributeEditable">
																												{% for val in attrEditable.Values %}
																													<option value="{{ val.ValueId }}">{{ val.Value }}</option>
																												{% endfor -%}
																											</select>
																											<div class="select__input">
																											<span class="selected-js" title="{{ attrEditable.Values[0].Value }}">
																												{{ attrEditable.Values[0].Value }}
																											</span>
																												<svg>
																													<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
																												</svg>
																											</div>
																											<ul class="select__options options-js">
																												{% for val in attrEditable.Values %}
																													<li data-value="{{ val.ValueId }}">{{ val.Value }}</li>
																												{% endfor -%}
																											</ul>
																										</div>
																									{% when 4 -%}
																										<label for="attrEditable-{{forloop.index}}" class="form__input-info input-info-js on-label">{{ attrEditable.Name }}</label>
																										<input id="attrEditable-{{forloop.index}}" class="form__input-value input-value-js" type="date" name="attributeEditable" value="" required >
																								{% endcase -%}
																								<div class="form__invalid-input validation-info-js validation-required-js hidden-js">
																									{{ translations.FillAttributeValue }}
																								</div>
																							</div>
																						</div>
																					{% endfor -%}
																				</td>
																			</tr>
																		{% else -%}
																			<tr class="hidden-js">
																				<td>
																					<input name="attributePolyvalent" type="hidden" value="{{ value.ValueId }}">
																				</td>
																			</div>
																		{% endif -%}
																	{% endfor -%}
																</tbody>
															</table>
														</div>
													{% endif -%}
												</div>
											{% endfor -%}
										{% elseif activeProduct.AttributesEditable[0] and product.AskForPrice == false and product.Archival == false -%}
											{% if settings.productIsInCart == 'productIsInCart-yes' -%}
												<input type="hidden" class="isInCartId" value="{{activeProduct.Id}}">
											{% endif -%}
											<div class="attributes-js">
												<div class="attributes__table-container attr-poly-table-js">
													<table>
														<thead>
															<tr>
																{% if config.ENTERPRISE -%}
																	<th class="netto-price-column">{{ translations.SubtotalPrice }}</th>
																	<th class="brutto-price-column">{% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}{{ translations.TotalPrice }}{% endunless -%}</th>
																{% else -%}
																	{% if customer.Cart.SubtotalPrices -%}
																		<th class="netto-price-column">{{ translations.SubtotalPrice }}</th>
																	{% else -%}
																		<th class="brutto-price-column">{{ translations.TotalPrice }}</th>
																	{% endif -%}
																{% endif -%}
																{% if product.StockLevel != null and showStock -%}
																	<th class="stock-column">{{ translations.Stock }}</th>
																{% endif -%}
																<th class="quantity-column">{{ translations.Quantity }}</th>
																<th class="unit-column">{{ translations.Unit }}</th>
															</tr>
														</thead>
														<tbody>
															{% if config.ENTERPRISE -%}
																{% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}
																	{% if settings.showUnitRateOnProductDetailsPage == 'yes' and product.Units[1] -%}
																		{% assign unitRatioInfoExists = true -%}
																	{% endif -%}
																{% endunless -%}
																{% if activeProduct.TotalPreviousPrice != null and activeProduct.TotalPreviousPrice > activeProduct.TotalPrice -%}
																	{% assign previousPriceExists = true -%}
																{% elseif activeProduct.TotalRegularPrice != null and activeProduct.TotalRegularPrice > activeProduct.TotalPrice -%}
																	{% assign previousPriceExists = true -%}
																{% endif -%}
															{% else -%}
																{% if customer.Cart.SubtotalPrices -%}
																	{% if settings.showUnitRateOnProductDetailsPage == 'yes' and product.Units[1] -%}
																		{% assign unitRatioInfoExists = true -%}
																	{% endif -%}
																	{% if activeProduct.PreviousPrice != null and activeProduct.PreviousPrice > activeProduct.Price -%}
																		{% assign previousPriceExists = true -%}
																	{% endif -%}
																{% else -%}
																		{% if settings.showUnitRateOnProductDetailsPage == 'yes' and product.Units[1] -%}
																			{% assign unitRatioInfoExists = true -%}
																		{% endif -%}
																		{% if activeProduct.PreviousPrice != null and activeProduct.PreviousPrice > activeProduct.Price -%}
																			{% assign previousPriceExists = true -%}
																		{% endif -%}
																{% endif -%}
															{% endif -%}
															<tr class="last-level-attribute child-js with-attributes" data-child-index="0" data-weight="{{ product.Weight }}" data-netweight="{{ product.NetWeight}}">
																{% assign activeProductUnitsSize = activeProduct.Units | Size -%}
																{% if settings.thresholds == 'yes' and activeProduct.HasThresholds and activeProduct.Price != null and activeProductUnitsSize == 1 -%}
																	<td class="thresholds-column" {% if config.ENTERPRISE -%} colspan="2" {% endif -%}>
																		{% assign whatPrice = translations.Brutto | Downcase -%}
																		{% if customer.Cart.SubtotalPrices -%}
																			{% assign whatPrice = translations.Netto | Downcase -%}
																		{% endif -%}
																		{% assign firstThreshold = activeProduct.Thresholds | First -%}
																		{% assign lastThreshold = activeProduct.Thresholds | Last -%}
																		<div class="thresholds-column__label">{{ translations.Price }} {{ whatPrice }}</div>
																		<div class="thresholds-column__range">
																			{{ translations.RangeFrom | Downcase }} <strong>{{ lastThreshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}</strong> {{ translations.RangeTo | Downcase }} {{ firstThreshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}
																		</div>
																		{% assign thresholdsSize = activeProduct.Thresholds | Size -%}
																		{% if thresholdsSize >= 2 -%}
																			<button class="thresholds-column__open-thresholds-popup pure-button open-next-element-js stop-propagation-js">
																			<span>{{ translations.SeePriceDetails }}</span>
																			</button>
																			<div class="popup-background hidden-js hide-js container-to-hide-js">
																				<div class="popup thresholds-popup">
																					<div class="popup__header">
																						<div class="title">{{ translations.PriceDetails }}</div>
																						<svg class="hide-container-js">
																							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
																						</svg>
																					</div>
																					<div class="popup__content">
																						<div class="name">{{ activeProduct.Name }}</div>
																						<div class="thresholds">
																							<div class="thresholds__row">
																								<span>{{ translations.Quantity }} [{{ {{ product.SaleUnit }} }}]:</span>
																								<span>{{ translations.Price }} {{ whatPrice }}:</span>
																							</div>
																							{% for threshold in activeProduct.Thresholds -%}
																								<div class="thresholds__row">
																									<div>{{ threshold.Threshold | Normalize }}+</div>
																									<div>{{ threshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}</div>
																								</div>
																							{% endfor %}
																						</div>
																					</div>
																				</div>
																			</div>
																		{% endif -%}
																	</td>
																{% elseif config.ENTERPRISE -%}
																	<td class="netto-price-column" data-netto-price="{{ activeProduct.SubtotalPrice | DividedBy: product.BasicUnitRatio }}">
																		<span class="netto-price-column__price">
																			<span class="netto-js">
																				{{ activeProduct.SubtotalPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }}
																			</span>
																			<span class="price">{{ currencyExt }}</span>
																			{% if activeProduct.SubtotalPreviousPrice != null and activeProduct.SubtotalPreviousPrice > activeProduct.SubtotalPrice -%}
																				<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																				{% if settings.previousPriceAsSuggestedRetailPrice == 'yes' %}
																					<div class="netto-price-column__lowest-price netto-previous-js" data-nettoprevious-price="{{ activeProduct.SubtotalPreviousPrice | DividedBy: product.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-nettolowest-price="{{ activeProduct.SubtotalMinPrice | DividedBy: product.BasicUnitRatio }}" {% endif -%}>{{ activeProduct.SubtotalPreviousPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.SuggestedRetailPrice}}</div>
																				{% else -%}
																					<div class="netto-price-column__previous-price" data-nettoprevious-price="{{ activeProduct.SubtotalPreviousPrice | DividedBy: product.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-nettolowest-price="{{ activeProduct.SubtotalMinPrice | DividedBy: product.BasicUnitRatio }}" {% endif -%}>
																						<span class="netto-previous-js">{{ activeProduct.SubtotalPreviousPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}</span>
																					</div>
																				{% endif -%}
																			{% elseif activeProduct.SubtotalRegularPrice != null and activeProduct.SubtotalRegularPrice > activeProduct.SubtotalPrice and settings.lowestProductPrice == 'no' -%}
																				<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																				<div class="netto-price-column__previous-price" data-nettoprevious-price="{{ activeProduct.SubtotalRegularPrice | DividedBy: product.BasicUnitRatio }}">
																					<span class="netto-previous-js">{{ activeProduct.SubtotalRegularPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} </span>
																				</div>
																			{% endif -%}
																		</span>
																		{% if activeProduct.DepositValue > 0 -%}
																			<span class="netto-price-column__deposit-price">
																				<span>+ {{translations.Com_Deposit}}: </span>
																				<span class="deposit-js" data-deposit-price="{{ activeProduct.DepositValue | DividedBy: product.BasicUnitRatio }}">
																					{{ activeProduct.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} / {{ activeProduct.BasicUnit }}
																				</span>
																			</span>
																		{% endif -%}
																		{% if settings.showUnitRateOnProductDetailsPage == 'yes' and product.Units[1] -%}
																			{% for unit in product.Units -%}
																				{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																					{% if unit.Id != unitId -%}
																						<div class="netto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																							{{ activeProduct.SubtotalPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{unitName}}
																						</div>
																					{% endif -%}
																				{% else -%}
																					{% if unit.Name != product.BasicUnit -%}
																						<div class="netto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																							{{ activeProduct.SubtotalPrice | DividedBy: product.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{product.BasicUnit}}
																						</div>
																					{% endif -%}
																				{% endif -%}
																			{% endfor -%}
																		{% endif -%}
																		{% if activeProduct.SubtotalPreviousPrice != null and activeProduct.SubtotalPreviousPrice > activeProduct.SubtotalPrice and settings.lowestProductPrice == 'yes' -%}
																			<div class="netto-price-column__lowest-price netto-lowest-js">{{ activeProduct.SubtotalMinPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.Price_Omnibus}}</div>
																		{% endif -%}
																	</td>
																	<td class="brutto-price-column" data-brutto-price="{{ activeProduct.TotalPrice | DividedBy: product.BasicUnitRatio }}">
																		{% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}
																			<span class="brutto-price-column__price">
																				<span class="brutto-js">
																					{{ activeProduct.TotalPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }}
																				</span>
																				<span class="price">{{ currencyExt }}</span>
																				{% if activeProduct.TotalPreviousPrice != null and activeProduct.TotalPreviousPrice > activeProduct.TotalPrice -%}
																					<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																					{% if settings.previousPriceAsSuggestedRetailPrice == 'yes' -%}
																						<div class="brutto-price-column__lowest-price {% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}brutto-previous-js{% endunless -%}" data-bruttoprevious-price="{{ activeProduct.TotalPreviousPrice | DividedBy: product.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-bruttolowest-price="{{ activeProduct.TotalMinPrice | DividedBy: product.BasicUnitRatio }}" {% endif -%}>{% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}{{ activeProduct.TotalPreviousPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.SuggestedRetailPrice}}{% endunless -%}</div>
																					{% else -%}
																						<div class="brutto-price-column__previous-price" data-bruttoprevious-price="{{ activeProduct.TotalPreviousPrice | DividedBy: product.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-bruttolowest-price="{{ activeProduct.TotalMinPrice | DividedBy: product.BasicUnitRatio }}" {% endif -%}>
																							{% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}<span class="brutto-previous-js">{{ activeProduct.TotalPreviousPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}</span>{% endunless -%}
																						</div>
																					{% endif -%}
																				{% elseif activeProduct.TotalRegularPrice != null and activeProduct.TotalRegularPrice > activeProduct.TotalPrice and settings.lowestProductPrice == 'no' -%}
																					<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																					<div class="brutto-price-column__previous-price" data-bruttoprevious-price="{{ activeProduct.TotalRegularPrice | DividedBy: product.BasicUnitRatio }}">
																						<span class="brutto-previous-js">{{ activeProduct.TotalRegularPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} </span>
																					</div>
																				{% endif -%}
																			</span>
																			{% if activeProduct.DepositValue > 0 -%}
																				<span class="brutto-price-column__deposit-price">
																					<span>+ {{translations.Com_Deposit}}: </span>
																					<span class="deposit-js" data-deposit-price="{{ activeProduct.DepositValue | DividedBy: product.BasicUnitRatio }}">
																						{{ activeProduct.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} / {{activeProduct.BasicUnit}}
																					</span>
																				</span>
																			{% endif -%}
																			{% if settings.showUnitRateOnProductDetailsPage == 'yes' and product.Units[1] -%}
																				{% for unit in product.Units -%}
																					{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																						{% if unit.Id != unitId -%}
																							<div class="brutto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																								{{ activeProduct.TotalPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{unitName}}
																							</div>
																						{% endif -%}
																					{% else -%}
																						{% if unit.Name != product.BasicUnit -%}
																							<div class="brutto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																								{{ activeProduct.TotalPrice | DividedBy: product.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{product.BasicUnit}}
																							</div>
																						{% endif -%}
																					{% endif -%}
																				{% endfor -%}
																			{% endif -%}
																			{% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}
																				{% if activeProduct.TotalPreviousPrice != null and activeProduct.TotalPreviousPrice > activeProduct.TotalPrice and settings.lowestProductPrice == 'yes' -%}
																					<div class="brutto-price-column__lowest-price brutto-lowest-js">{{ activeProduct.TotalMinPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.Price_Omnibus}}</div>
																				{% endif -%}
																			{% endunless -%}
																		{% endunless -%}
																	</td>
																{% else -%}
																	{% if customer.Cart.SubtotalPrices -%}
																		<td class="netto-price-column" data-netto-price="{{ activeProduct.Price | DividedBy: product.BasicUnitRatio }}">
																			<span class="netto-price-column__price">
																				<span class="netto-js">
																					{{ activeProduct.Price | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }}
																				</span>
																				<span class="price">{{ currencyExt }}</span>
																				{% if activeProduct.PreviousPrice != null and activeProduct.PreviousPrice > activeProduct.Price -%}
																					<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																					{% if settings.previousPriceAsSuggestedRetailPrice == 'yes' %}
																						<div class="netto-price-column__lowest-price netto-previous-js" data-nettoprevious-price="{{ activeProduct.PreviousPrice | DividedBy: product.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-nettolowest-price="{{ activeProduct.MinPrice | DividedBy: product.BasicUnitRatio }}" {% endif -%}>{{ activeProduct.PreviousPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.SuggestedRetailPrice}}</div>
																					{% else -%}
																						<div class="netto-price-column__previous-price" data-nettoprevious-price="{{ activeProduct.PreviousPrice | DividedBy: product.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-nettolowest-price="{{ activeProduct.MinPrice | DividedBy: product.BasicUnitRatio }}" {% endif -%}>
																							<span class="netto-previous-js">{{ activeProduct.PreviousPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}</span>
																						</div>
																					{% endif -%}
																				{% endif -%}
																			</span>
																			{% if activeProduct.DepositValue > 0 -%}
																				<span class="netto-price-column__deposit-price">
																					<span>+ {{translations.Com_Deposit}}: </span>
																					<span class="deposit-js" data-deposit-price="{{ activeProduct.DepositValue | DividedBy: product.BasicUnitRatio }}">
																						{{ activeProduct.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} / {{activeProduct.BasicUnit}}
																					</span>
																				</span>
																			{% endif -%}
																			{% if settings.showUnitRateOnProductDetailsPage == 'yes' and product.Units[1] -%}
																				{% for unit in product.Units -%}
																					{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																						{% if unit.Id != unitId -%}
																							<div class="netto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																								{{ activeProduct.Price | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{unitName}}
																							</div>
																						{% endif -%}
																					{% else -%}
																						{% if unit.Name != product.BasicUnit -%}
																							<div class="netto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																								{{ activeProduct.Price | DividedBy: product.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{product.BasicUnit}}
																							</div>
																						{% endif -%}
																					{% endif -%}
																				{% endfor -%}
																			{% endif -%}
																			{% if activeProduct.PreviousPrice != null and activeProduct.PreviousPrice > activeProduct.Price and settings.lowestProductPrice == 'yes' -%}
																				<div class="netto-price-column__lowest-price netto-lowest-js">{{ activeProduct.MinPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.Price_Omnibus}}</div>
																			{% endif -%}
																		</td>
																	{% else -%}
																		<td class="brutto-price-column" data-brutto-price="{{ activeProduct.Price | DividedBy: product.BasicUnitRatio }}">
																			<span class="brutto-price-column__price">
																				<span class="brutto-js">
																					{{ activeProduct.Price | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }}
																				</span>
																				<span class="price">{{ currencyExt }}</span>
																				{% if activeProduct.PreviousPrice != null and activeProduct.PreviousPrice > activeProduct.Price -%}
																					<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																					{% if settings.previousPriceAsSuggestedRetailPrice == 'yes' -%}
																						<div class="brutto-price-column__lowest-price brutto-previous-js" data-bruttoprevious-price="{{ activeProduct.PreviousPrice | DividedBy: product.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-bruttolowest-price="{{ activeProduct.MinPrice | DividedBy: product.BasicUnitRatio }}" {% endif -%}>{{ activeProduct.PreviousPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.SuggestedRetailPrice}}</div>
																					{% else -%}
																						<div class="brutto-price-column__previous-price" data-bruttoprevious-price="{{ activeProduct.PreviousPrice | DividedBy: product.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-bruttolowest-price="{{ activeProduct.MinPrice | DividedBy: product.BasicUnitRatio }}" {% endif -%}>
																							<span class="brutto-previous-js">{{ activeProduct.PreviousPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}</span>
																						</div>
																					{% endif -%}
																				{% endif -%}
																			</span>
																			{% if activeProduct.DepositValue > 0 -%}
																				<span class="brutto-price-column__deposit-price">
																					<span>+ {{translations.Com_Deposit}}: </span>
																					<span class="deposit-js" data-deposit-price="{{ activeProduct.DepositValue | DividedBy: product.BasicUnitRatio }}">
																						{{ activeProduct.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} / {{activeProduct.BasicUnit}}
																					</span>
																				</span>
																			{% endif -%}
																			{% if settings.showUnitRateOnProductDetailsPage == 'yes' and product.Units[1] -%}
																				{% for unit in product.Units -%}
																					{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																						{% if unit.Id != unitId -%}
																							<div class="brutto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																								{{ activeProduct.Price | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{unitName}}
																							</div>
																						{% endif -%}
																					{% else -%}
																						{% if unit.Name != product.BasicUnit -%}
																							<div class="brutto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																								{{ activeProduct.Price | DividedBy: product.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{product.BasicUnit}}
																							</div>
																						{% endif -%}
																					{% endif -%}
																				{% endfor -%}
																			{% endif -%}
																			{% if activeProduct.PreviousPrice != null and activeProduct.PreviousPrice > activeProduct.Price and settings.lowestProductPrice == 'yes' -%}
																				<div class="brutto-price-column__lowest-price brutto-lowest-js">{{ activeProduct.MinPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.Price_Omnibus}}</div>
																			{% endif -%}
																		</td>
																	{% endif -%}
																{% endif -%}
																{% if product.StockLevel != null and showStock -%}
																	<td class="stock-column" {% if activeProduct.StockLevel != null and activeProduct.StockLevel.QuantityControl == false and showStock -%} data-stock-not-max-value="{{ activeProduct.StockLevel.Value | Normalize }}" data-basic-unit="{{ product.BasicUnitRatio }}" {% endif -%}>
																		<div class="stock-column-data">
																			
																			{% if activeProduct.StockLevel.ImageUrl != null -%}
																				{% if activeProduct.StockLevel.Type == 1 or activeProduct.StockLevel.Type == 2 -%}
																					<img alt="{{ activeProduct.StockLevel.Text }}" {% if activeProduct.StockLevel.Text != null -%} {% if activeProduct.StockLevel.Type == 1 or activeProduct.StockLevel.Type == 3 -%} title="{{ activeProduct.StockLevel.Text }}" {% endif -%} {% endif -%} src="css/img/alo.gif" data-src="{{ activeProduct.StockLevel.ImageUrl }}">
																				{% endif -%}
																			{% elseif activeProduct.StockLevel.Text != null and activeProduct.StockLevel.Type == 3 -%}
																				{{ activeProduct.StockLevel.Text }}
																			{% else -%}
																				<span class="max-js">
																					{% if activeProduct.StockLevel.Value < 1000000 -%}
																						{% if config.Products.DecimalUnits -%}
																							{{ activeProduct.StockLevel.Value | Normalize }}
																						{% else -%}
																							{{ activeProduct.StockLevel.Value | Floor }}
																						{% endif -%}
																					{% else -%}
																						{{ translations.Limitless }}
																					{% endif -%}
																				</span>
																			{% endif -%}
																		</div>
																	</td>
																{% endif -%}
																{% assign attributeIndex = forloop.index0 -%}
																<td class="quantity-column ammount-stepper-js" data-quantity="{% if config.Products.DecimalUnits -%}0{{ config.DecimalSeparator }}00{% else -%}0{% endif -%}" {% if activeProduct.StockLevel != null and activeProduct.StockLevel.QuantityControl and showStock -%} data-stock-value="{{ activeProduct.StockLevel.Value | Normalize }}" data-basic-unit="{{ product.BasicUnitRatio }}" {% endif -%}>
																	{% include 'partials/product/amount-stepper.html' with activeProduct -%}
																</td>
																{% assign unitRatioInfo = false -%}
																{% if product.Units[1] and settings.showUnitRateOnProductDetailsPage == 'yes' and settings.showUnitRateOnProductDetailsPageUnit == 'basic' and unitName != product.BasicUnit -%}
																	{% assign unitRatioInfo = true -%}
																{% endif -%}
																<td class="unit-column unit-ratio-js" data-unit="{{ unitId }}" data-unit-ratio-info="{{unitRatioInfo}}" data-basic-unit-ratio="{{product.BasicUnitRatio}}">
																	{% if product.Units[1] -%}
																		<div tabindex="0" class="unit-column__units select select-js">
																			<select id="unit-select-{{ product.Id }}-{{ forloop.index0 }}" class="memory-js" data-index="{{ forloop.index0 }}" aria-label="{{ translations.Unit }}">
																				{% for unit in product.Units -%}
																					{% if unit.Id == unitId -%}
																						{% assign defaultUnitName = unit.Name -%}
																					{% endif -%}
																					<option value="{{ unit.Id }}" {% if unit.Id == unitId -%} selected {% endif -%}>{{ unit.Name | H }}</option>
																				{% endfor -%}
																			</select>
																			<div class="select__input">
																				<span class="selected-js">
																					{{ defaultUnitName | H }}
																				</span>
																				<svg>
																					<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
																				</svg>
																			</div>
																			<ul class="select__options options-js units-in-table-js">
																				{% for unit in product.Units -%}
																					<li data-ratio="{{ unit.Ratio }}" data-value="{{ unit.Id }}" {% if unit.Multiplicity > 0 -%} data-multiplicity="{{ unit.Multiplicity }}" {% endif -%}>{{ unit.Name | H }}</li>
																				{% endfor -%}
																			</ul>
																		</div>
																		<div class="unit-column__unit-ratio-info">
																			{% if settings.showUnitRateOnProductDetailsPage == 'yes' -%}
																				{% assign productUnitsSize = product.Units | Size -%}
																				{% for unit in product.Units -%}
																					{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																						{% if unit.Id != unitId -%}
																							<span class="unit-ratio-info-js {% if productUnitsSize > 1 -%} hidden-js {% endif -%}" data-id="{{unit.Id}}">{{ unit.Ratio | DividedBy: unitRatio | Round: 4 }} {{ unitName }}</span>
																						{% endif -%}
																					{% else -%}
																						{% if unit.Name != supplyProduct.BasicUnit -%}
																							<span class="unit-ratio-info-js {% if productUnitsSize > 1 -%} hidden-js {% endif -%}" data-id="{{unit.Id}}">{{ unit.Ratio | Round: 4 }} {{ product.BasicUnit }}</span>
																						{% endif -%}
																					{% endif -%}
																				{% endfor -%}
																			{% endif -%}
																		</div>
																	{% else -%}
																		{{ product.SaleUnit }}
																	{% endif -%}
																	{% if supplyProduct.BasicUnitMinQuantity > 1 -%}
																		<div class="min-quantity-info">
																			<svg>
																				<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#exclamation-triangle-{{settings.iconStyle}}'></use>
																			</svg>
																			<span>
																				{{ translations.FillProperMinQuantity }} <strong>{{ supplyProduct.BasicUnitMinQuantity | Round }} {{ supplyProduct.BasicUnit }}</strong>
																			</span>
																		</div>
																	{% endif -%}
																</td>
																{% if showCouponsPopup -%}
																	<td>
																		<div class="product-item__coupons-container product-container">
																			<input type="hidden" name="productId" value="{{ activeProduct.Id }}" />
																			<input type="hidden" name="productCode" value="{{ activeProduct.Code | H }}" />
																			<input type="hidden" name="productName" value="{{ activeProduct.NameNoHtml | H }}" />
																			{% if activeProduct.ImageId != -1 -%}
																				<input type="hidden" name="productImage" value="img/small/{{ activeProduct.ImageId }}/product.jpg" />
																			{% elsif activeProduct.Image -%}
																				<input type="hidden" name="productImage" value="{{ activeProduct.Image }}" />
																			{% else -%}
																				<input type="hidden" name="productImage" value="" />
																			{% endif -%}
																			<button class="show-more-coupons-product-list show-more-coupons-product-list-js" style="position: relative;z-index: 2;" data-product-id="{{activeProduct.Id}}" data-url="{{ page.BaseHref }}{{product.Url}}">{{ translations.ShowDiscounts }}</button>
																		</div>
																	</td>
																{% endif -%}
															</tr>
															<tr class="last-level-attribute" data-child-index="0" data-weight="{{ product.Weight }}" data-netweight="{{ product.NetWeight}}">
																<td colspan="100%" class="last-level-attribute__more-attributes">
																	<input name="attributePolyvalent" type="hidden" value="{{ value.ValueId }}">
																	{% for attrEditable in activeProduct.AttributesEditable -%}
																		<div class="attribute-editable attribute-container-js">
																			<div class="form__input-wrapper">
																				{% case attrEditable.Format -%}
																					{% when 1 -%}
																						<label for="attrEditable-{{forloop.index}}" class="form__input-info input-info-js">{{ attrEditable.Name }}</label>
																						<input id="attrEditable-{{forloop.index}}" class="form__input-value input-value-js" type="text" name="attributeEditable" value="" maxlength="50" required >
																						<div class="form__input-value--clear-button">
																							<svg>
																								<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
																							</svg>
																						</div>	
																					{% when 2 -%}
																						<label for="attrEditable-{{forloop.index}}" class="form__input-info input-info-js">{{ attrEditable.Name }}</label>
																						<input id="attrEditable-{{forloop.index}}" class="form__input-value input-value-js" type="number" name="attributeEditable" value="" max="999999999999999" required >
																					{% when 3 -%}
																						<label for="attrEditable-{{forloop.index}}" class="form__input-info input-info-js">{{ attrEditable.Name }}</label>
																						<div tabindex="0" class="select select-js">
																							<select id="attrEditable-{{forloop.index}}" class="memory-js" name="attributeEditable">
																								{% for val in attrEditable.Values %}
																									<option value="{{ val.ValueId }}">{{ val.Value }}</option>
																								{% endfor -%}
																							</select>
																							<div class="select__input">
																							<span class="selected-js" title="{{ attrEditable.Values[0].Value }}">
																								{{ attrEditable.Values[0].Value }}
																							</span>
																								<svg>
																									<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
																								</svg>
																							</div>
																							<ul class="select__options options-js">
																								{% for val in attrEditable.Values %}
																									<li data-value="{{ val.ValueId }}">{{ val.Value }}</li>
																								{% endfor -%}
																							</ul>
																						</div>
																					{% when 4 -%}
																						<label for="attrEditable-{{forloop.index}}" class="form__input-info input-info-js on-label">{{ attrEditable.Name }}</label>
																						<input id="attrEditable-{{forloop.index}}" class="form__input-value input-value-js" type="date" name="attributeEditable" value="" required >
																				{% endcase -%}
																				<div class="form__invalid-input validation-info-js validation-required-js hidden-js">
																					{{ translations.FillAttributeValue }}
																				</div>
																			</div>
																		</div>
																	{% endfor -%}
																</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										{% endif -%}
									{% endif -%}
								{% endunless -%}
							</div>
						<div class="attributes__buttons">
							{% if noProductOnControlledStock and tableView == false -%}
								{% assign noSimpleProductOnControlledStock = true -%}
							{% else -%}
								{% assign noSimpleProductOnControlledStock = false -%}
							{% endif -%}
							{% if noProductOnControlledStock and tableView and product.Clip == false and product.Batch == false and inLookbook == false -%}
								{% assign noSimpleProductWithAttributesOnControlledStock = true -%}
							{% else -%}
								{% assign noSimpleProductWithAttributesOnControlledStock = false -%}
							{% endif -%}
							{% if customer.HidePrices == false and noSimpleProductOnControlledStock == false and noSimpleProductWithAttributesOnControlledStock == false -%}
								{% unless joinedKeys == product.Supplies.Key and unitId == null -%}
									{% assign newQuery = true -%}
									{% capture dataUrl -%}{{ url }}?{% endcapture -%}
									{% if joinedKeys != product.Supplies.Key -%}
										{% capture dataUrl -%}{{ dataUrl }}keys={{ joinedKeys }}{% endcapture -%}
									{% endif -%}
									{% assign lastSign = dataUrl | Last -%}
									{% if unitId != null -%}
										{% if lastSign == '?' -%}
											{% capture dataUrl -%}{{ dataUrl }}unit={{ unitId }}{% endcapture -%}
										{% else -%}
											{% capture dataUrl -%}{{ dataUrl }}&unit={{ unitId }}{% endcapture -%}
										{% endif -%}
									{% endif -%}
								{% endunless -%}
								{% if canBuy -%}
									{% if settings.redirectCustomer == 'yes' and product.MoreInfoUrl != '' -%}
										<a href="{{ product.MoreInfoUrl }}" target="_blank" rel="noopener noreferrer">{{ translations.SeeMore }}</a>
									{% else -%}
										<form method="dialog">
											<button class="pure-button close-js">
												<svg class="pure-button__icon">
													<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-left-{{settings.iconStyle}}"></use>
												</svg>
												<span class="pure-button__text">{{ translations.CloseWithoutAdding }}</span>
											</button>
										</form>
										<button class="primary-action-button add-from-presentation-js add-to-cart-button-js parent-container-reload-js {% if tableView -%} add-many-products-js {% else -%} add-to-cart-update-client-area-js {% endif -%}" {% if newQuery and settings.afterAddingToCart != 1 -%}data-url="{{ dataUrl }}"{% endif -%} {% if customer.Carts[1] -%} data-current-cart-id="{{ currentCartId }}" {% endif -%} data-id="{{product.Id}}">
											<span class="primary-action-button__text">{{ translations.AddToCart }}</span>
											<svg class="primary-action-button__icon">
												<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#shopping-cart-{{settings.iconStyle}}"></use>
											</svg>
										</button>
									{% endif -%}
								{% endif -%}
							{% endif -%}
						</div>
                {% endunless -%}
            {% endif -%}
        </div>
    </div>
</dialog>
`